/*eslint-disable */
import Axios from "axios";
import {
  ErrorMessage, Field as Fieldmik,
  FieldArray, Form as Formiker, Formik,
  getIn
} from "formik";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table as TableB } from 'react-bootstrap';
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Button, Dropdown, Form as FormUi, Grid, Icon, Input, Modal, Table
} from "semantic-ui-react";
import * as yup from "yup";
import { successAlertDispatcher , errorAlertDispatcher} from "../../redux/actions/alertAction";
import { createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import { AllRegex } from "../../utils/validation";
import { INVALID_FIELDS } from "../../utils/validationConstant";
import MyPSLineItem from "../apiInputs/mypslineItem";
import ReadAxios from "../axiosComponent/read";
import ReadMasterAxios from "../axiosComponent/readMaster";
import MandatoryMark from "../common/mandatorymark";
import MyBillingPartyComponent from "../dynamicComponent/billingparty";
import BillingPartyBranchDropdown from "../dynamicComponent/billingPartyBranchDropdown";
import BillingPartyDropdown from "../dynamicComponent/billingPartyDropdown";
import MyConsigneeComponent from "../dynamicComponent/consignee";
import MyConsignor from "../dynamicComponent/consignor";
import { DateData } from "../dynamicComponent/datepick";
import {
  MyInput,
  MyNormalInput,
  MyNumInput,
  MyTextArea
} from "../dynamicComponent/myInputs";
import ErrorMessages from "./ErrorMessages";
import ModalCreateConsignee from "./modalCreateConsignee";
import ModalCreateConsignor from "./modalCreateConsigner";
import SearchDropdown from "./searchDropdown";
import MySKU from "../dynamicComponent/mySKU";
import { FEATURES } from "../../utils/constant";
import MyUser from "../apiInputs/myUser";

const ModalEditAddDeliveries = (props, { setFieldValue }) => {
  const getIntialCall = async () => {
    let productsArray = null
    let dataArray = null
    let serviceArray = null
    let loadArray = null
    let branchArray = null
    console.log({props: props.OpenModel})
    if(props.OpenModel){
    [
      // productsArray,
       dataArray, serviceArray, loadArray, branchArray] =
      await Promise.all([
        // ReadAxios({ url: "skuMaster" }),
        ReadAxios({ url: `vehicleTypeMaster` }),
        ReadAxios({ url: `psCategoryMaster` }),
      ]);
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    serviceArray = isEmpty(serviceArray) ? [] : serviceArray.data;
    loadArray = isEmpty(loadArray) ? [] : loadArray.data;
    // productsArray = isEmpty(productsArray) ? [] : productsArray.data.resultSet;

    if (branchArray)
      setbranchArray(
        branchArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.branchName,
            value: item.branchId,
            raw: { ...item },
          };
        })
      );

    if (dataArray)
      setvehicletype(
        dataArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType + " " + "(" + item.vehicleTypeTonnage + ")",
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
      );

    // if (productsArray) {
    //   setproducts(
    //     productsArray.map((item, index) => {
    //       return {
    //         key: index + 1,
    //         text: item.skuCode,
    //         value: item.skuCode,
    //         raw: { ...item },
    //       };
    //     })
    //   );
    // }
  }
  };

  const [yard, setyard] = useState([]);
  const [cha, setcha] = useState([]);
  const [shipingline, setshipingline] = useState([]);
  const [products, setproducts] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [ownership, setownershiptype] = useState([]);
  const [customertype, setcustomertype] = useState([]);
  const [billingparty, setBillingParty] = useState([]);
  const [billingpartybranch, setBillingPartyBranch] = useState([]);
  const [branchs, setbranchArray] = useState([]);
  const [userbranchs, setUserbranchArray] = useState([]);
  const [ownvendor, setOwnVendor] = useState([]);
  const [containerType, setcontainerType] = useState([]);
  const [service, setService] = useState([]);
  const [load, setLoad] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [checkowner, setcheckowner] = useState(2);
  const [consignorArray, setConsignorArray] = useState([]);
  const [consigneeArray, setConsigneeArray] = useState([]);
  const [componentReload, setcomponentReload] = useState(0);

  const [addDeliveryList, setAddDeliveryList] = useState(0);
  const [serviceCateogyList, setServiceCateogyList] = useState([]);
  const [packageType, setPackageType] = useState([]);
  const [proposedFreightRateValue, setProposedFreightRateValue] = useState(0);

  const [initalValue, setInitalValue] = useState({});
  const [lrNumbers , setLrNumbers] = useState({})

  useEffect(() => {
    //getServiceType();
    //getOwnershipType();
    getShipingLine();
    getYard();
    getCha();
    getCustomerType();
    getBranch();
    //getLoadType();
    getIntialCall();
    getCurrentUserBranch();
    //getOwnVendors();
    getContainerType();
    getServiceCategory();
    getPackageType();

    let fetchedInitValue = generateInitialValues();
    setInitalValue(fetchedInitValue);
  }, [componentReload, props?.movement_type, props?.deliveryDataFetch]);

  const evaluateFreightRate = (value, setFieldValue, proposedFreightRate, actualFreightRate, finalFreightRate, CFTKGFactor, index) => {

    let optionsUOM = [
      { key: "4", text: "Trip", value: "trip" },
      { key: "2", text: "KG", value: "kg" },
      { key: "5", text: "Ton", value: "ton" },
      { key: "6", text: "KM", value: "km" },
      { key: "7", text: "Per Case", value: "percase" },
      { key: "8", text: "CFT", value: "cft" },
      { key: "9", text: "CFT KG Factor", value: "CFTKGFactor" },
    ]
    let UomSelected;
    optionsUOM.forEach(element => {
      if (element.value == value.deliveries[index].uom) {
        UomSelected = element.key;
      }
    });
  };
  
  const handleLRSeriesNo = async (bookingBranchId, index, setFieldValue) => {
    if(lrNumbers && lrNumbers[index] && lrNumbers[index][bookingBranchId]){
      if(lrNumbers[index][bookingBranchId].defaultLR){
        setFieldValue(`deliveries[${index}].lr_no`, lrNumbers[index][bookingBranchId].defaultLR)
        setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
      }else{
        var difference = (new Date() - lrNumbers[index][bookingBranchId].time);
        difference = Math.round((difference/1000)/60);
        if(difference >= 30 ){
          let lr_numbers = lrNumbers
          lr_numbers[index][bookingBranchId]=null
          setLrNumbers(lr_numbers)
        }else{
          if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, lrNumbers[index][bookingBranchId].lrNumber)
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
          }
        }
      }
    }else{
      let lrNumber = await getLRSeriesNumber(bookingBranchId)
      if (lrNumber) {
        let currentTime = new Date()
        let lr_numbers = lrNumbers
        lr_numbers[index]= lr_numbers[index] || {}
        lr_numbers[index][bookingBranchId] = {lrNumber,time : currentTime}
        setLrNumbers(lr_numbers)
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, lrNumber)
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
        }
      }else{
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, "")
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, false)
        }
      }
    }
  }
  const getLRSeriesNumber = async (bookingBranchId) => {
    try {
      let lrResponse = await ReadAxios({ completeURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/lrseries/lrnumber?branch_id=${bookingBranchId}` })
      return lrResponse?.data?.lr_number;
    } catch (err) {
      props.errorAlertDispatcher({
        type: "error",
        messageHeader: "Error",
        messageBody: err.response?.data?.message || "Couldn't Fetch LR Number From LR Series",
      });
      return false
      console.log(err);
    }
  }

  const getPackageType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/packaging_type`,
    })
      .then((result) => {
        let data = result.data.resultSet;
        let list = data.map((item, index) => {
          return {
            key: item.packagingTypeId,
            text: item.packagingType,
            value: item.packagingTypeId,
            raw: { ...item },
          };
        });
        setPackageType(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getServiceCategory = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/service_category`,
    })
      .then((result) => {
        let data = result.data.resultSet;
        let list = data.map((item, index) => {
          return {
            key: item.serviceCategoryId,
            text: item.serviceCategory,
            value: item.serviceCategoryId,
            raw: { ...item },
          };
        });
        setServiceCateogyList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getContainerType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/container_type`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcontainerType(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.containerType,
              value: item.containerTypeId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCha = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cha` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcha(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.CHAName,
              value: item.CHAId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getShipingLine = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/shippingLine`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setshipingline(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.shippingLine,
              value: item.shippingLineId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getYard = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/yard` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setyard(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: `${item.yardCode} - ${item.yardName}`,
              value: item.yardId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCurrentUserBranch = () => {
    let temparray = localStorage.getItem("branchIds");
    ReadAxios({
      url: `branch`,
      mainUserId: Number(localStorage.getItem("userId")),
    })
      .then((res) => {
        setLoading(false);
        let branchArray = res.data.resultSet;
        if (temparray != "") {
          let temp = temparray.split(",");
          let tempa = [];
          for (let index = 0; index < branchArray.length; index++) {
            for (let indexj = 0; indexj < temp.length; indexj++) {
              if (branchArray[index].branchId == +temp[indexj]) {
                tempa.push(branchArray[index]);
              }
            }
          }
          setUserbranchArray(
            tempa.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        } else {
          setUserbranchArray(
            branchArray.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkOwnership = (data) => {
    setcheckowner(data.value);
  };

  const getBranch = () => {
    ReadAxios({
      url: `branch`,
      mainUserId: Number(localStorage.getItem("userId")),
    })
      .then((res) => {
        setLoading(false);
        let branchArray = res.data.resultSet;
        setbranchArray(
          branchArray.map((item, index) => {
            return {
              key: index + 1,
              text: item.branchName,
              value: item.branchName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        setLoading(false);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkBillingParty = (name, data, setFieldValue, customerTypeId, customerTypeName) => {
    let btemparray = localStorage.getItem("billingpartbranchIds");
    if (localStorage.getItem('customerNumber') === '503 ' || '1360 ' || '549' || '353') {
      ReadMasterAxios({
        completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping?${data.value}`,
        mainUserId: Number(localStorage.getItem("userId")),
        billingPartyId: data.value,
      }).then((res) => {
        if (res.data.status == 200) {
          let ownership = res.data.resultSet[0].paymentType;
          setcustomertype(
            ownership.map((item, index) => {
              return {
                key: index,
                value: item.id,
                text: item.name,
                raw: { ...item },
              };
            })
          );
          setFieldValue(customerTypeId, ownership[0].id)
          setFieldValue(customerTypeName, ownership[0].name)
        }
        else if (res.data.status == 204) {
          getCustomerType()
        }
      }).catch((err) => {

      })
    }
    ReadMasterAxios({
      completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_branch`,
      mainUserId: Number(localStorage.getItem("userId")),
      billingPartyId: data.value,
    })
      .then((response) => {
        let options = response.data.resultSet;
        if (btemparray != "") {
          let btemp = btemparray.split(",");
          let btempa = [];
          for (let index = 0; index < options.length; index++) {
            for (let indexj = 0; indexj < btemp.length; indexj++) {
              if (options[index].billingPartyBranchId == +btemp[indexj]) {
                btempa.push(options[index]);
              }
            }
          }
          setBillingPartyBranch(
            btempa.map((item, index) => {
              return {
                key: index,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            })
          );
        } else {
          setBillingPartyBranch(
            options.map((item, index) => {
              return {
                key: index,
                value: item.billingPartyBranchId,
                text: item.billingPartyBranchName,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const addNewDelivery = (arrayHelpers) => {
    if (props.shipment.create.movement_type == "import") {
      if (
        props.shipment.create.no_of_vehicles <=
        arrayHelpers.form.values.deliveries.length
      ) {
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Warning",
          messageBody:
            "Can not create more Deliveries then required containers.",
        });
      } else {
        arrayHelpers.push({
          delivery_number: "",
          delivery_reference_no: null,
          lr_no: null,
          is_lr_generated_by_lr_series : false,
          lr_date: props.reqon,
          lr_date_t: props.reqon,
          actual_weight: null,
          gross_weight: null,
          remarks: null,
          charged_weight: 0, //null,
          total_quantity: 0, //null,
          customer_type_id: null,
          billing_party_id: null,
          billing_party_branch_id: null,
          billing_party_branch_name: "",
          booking_branch_id: null,
          booking_branch_name: "",
          billing_branch_id: null,
          billing_branch_name: "",
          deliver_to: "consignee",
          deliver_to_branch_id: null,
          deliver_to_address: null,
          consignor_code: "",
          consignor_name: "",
          consignee_code: "",
          consignee_name: "",
          consignee_address: "",
          consignor_address: "",
          consignor_gstNumber: "",
          consignee_gstNumber: "",
          consignee_id: "",
          consignor_id: "",
          min_temp: null,
          max_temp: null,
          movement_type: null,
          route_placeholder: null,
          route_id: null,
          route: null,
          container_no: null,
          container_type: null,
          container_type_id: null,
          container_seal_no: "",
          yard_id: null,
          shipping_line_id: null,
          cha_id: null,
          container_pickup_date: props.reqon,
          container_pickup_date_t: props.reqon,
          delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
          delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),
          boarding_no: null,
          import_declaration_no: null,
          do_no: null,
          do_validity_date: null,
          do_validity_date_t: null,
          proposed_freight_rate: 0,
          actual_freight_rate: 0,
          final_freight_rate: 0,
          final_rate: 0,
          uom: "ton",
          CFTKGFactor: 0,
          products: [
            {
              product_code: null,
              product_name: null,
              quantity: null,
              product_category_id: null,
              product_category_name: null,
              packaging_type_id: null,
              invoice_no: null,
              length: 0,
              breadth: 0,
              height: 0,
            },
          ],
          invoices: [
            {
              invoice_no: null,
              invoice_reference_no:null,
              invoice_date: null,
              invoice_quantity: null, //null,
              invoice_amount: null, //null,
              bl_no: null,
              eway_bill_expirydate: null,
              eway_bill_no: null
            },
          ],
        });
      }
    } else {
      arrayHelpers.push({
        delivery_number: "",
        delivery_reference_no: null,
        lr_no: null,
        is_lr_generated_by_lr_series : false,
        lr_date: props.reqon,
        lr_date_t: props.reqon,
        actual_weight: null,
        gross_weight: null,
        remarks: null,
        charged_weight: 0, //null,
        total_quantity: 0, //null,
        customer_type_id: null,
        billing_party_id: null,
        billing_party_branch_id: null,
        deliver_to: "consignee",
        deliver_to_branch_id: null,
        billing_party_branch_name: "",
        deliver_to_address: null,
        booking_branch_id: null,
        booking_branch_name: "",
        billing_branch_id: null,
        billing_branch_name: "",
        other: null,
        consignor_code: "",
        consignor_name: "",
        consignee_code: "",
        consignee_name: "",
        consignee_address: "",
        consignor_address: "",
        consignor_gstNumber: "",
        consignee_gstNumber: "",
        consignee_id: "",
        consignor_id: "",
        min_temp: null,
        max_temp: null,
        movement_type: null,
        route_placeholder: null,
        route_id: null,
        route: null,
        container_no: null,
        container_type: null,
        container_type_id: null,
        container_seal_no: "",
        yard_id: null,
        shipping_line_id: null,
        cha_id: null,
        container_pickup_date: props.reqon,
        container_pickup_date_t: props.reqon,
        delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
        delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),
        do_no: null,
        boarding_no: null,
        import_declaration_no: null,
        do_validity_date: null,
        do_validity_date_t: null,
        proposed_freight_rate: 0,
        actual_freight_rate: 0,
        final_freight_rate: 0,
        final_rate: 0,
        uom: "ton",
        CFTKGFactor: 0,
        products: [
          {
            product_code: null,
            product_name: null,
            quantity: null,
            product_category_id: null,
            product_category_name: null,
            packaging_type_id: null,
            invoice_no: null,
            length: 0,
            breadth: 0,
            height: 0,
          },
        ],
        invoices: [
          {
            invoice_no: null,
            invoice_reference_no:null,
            invoice_date: null,
            invoice_quantity: null, //null,
            invoice_amount: null, //null,
            bl_no: null,
            eway_bill_expirydate: null,
            eway_bill_no: null
          },
        ],
      });
    }
  };

  if (props?.onlyDelivery) {
    if (props.movement_type == "import") {
      var validationSchema = yup.object().shape({
        deliveries: yup.array().of(
          yup.object().shape(
            {
              delivery_number: yup.string().optional(),
              delivery_reference_no: yup.string().nullable().optional(),
              booking_branch_id: yup.number().nullable().optional(),
              billing_branch_id: yup.number().nullable().optional(),
              lr_no: yup.string().nullable().optional(),
              lr_date: yup.string().nullable().optional(),
              lr_date_t: yup.string().nullable().optional(),
              actual_weight: yup.number().nullable().optional(),
              gross_weight: yup.number().nullable().optional(),
              charged_weight: yup.number().nullable().optional(),
              total_quantity: yup.number().nullable().optional(),
              customer_type_id: yup.number().nullable().optional(),
              billing_party_id: yup.number().nullable().optional(),
              billing_party_branch_id: yup.number().nullable().optional(),
              deliver_to: yup.string().nullable().optional(),
              deliver_to_branch_id: yup.number().nullable().optional(),
              deliver_to_address: yup.string().nullable().optional(),
              other: yup.string().nullable().optional(),
              consignor_code: yup.string().required("required"),
              consignee_code: yup.string().required("required"),
              pickup_area: yup.string().optional(),
              drop_area: yup.string().optional(),
              consignee_address: yup.string().nullable().optional(),
              consignor_address: yup.string().nullable().optional(),
              consignor_gstNumber: yup.string().nullable().optional(),
              consignee_gstNumber: yup.string().nullable().optional(),
              boarding_no: yup.string().optional().nullable(),
              import_declaration_no: yup.string().optional().nullable(),
              do_no: yup.string().nullable().optional(),
              do_validity_date: yup.string().nullable().optional(),
              do_validity_date_t: yup.string().nullable().optional(),
              min_temp: yup
                .number()
                .optional()
                .nullable()
                .when("max_temp", (max_temp) =>
                  max_temp
                    ? yup.number().optional().nullable().max(max_temp, "max")
                    : yup.number().optional().nullable()
                ),
              max_temp: yup
                .number()
                .optional()
                .nullable()
                .when("min_temp", (min_temp) =>
                  min_temp
                    ? yup.number().optional().nullable().min(min_temp, "min")
                    : yup.number().optional().nullable()
                ),
              container_no: yup.string().optional().nullable(),
              container_pickup_date: yup.string().optional().nullable(),
              container_pickup_date_t: yup.string().optional().nullable(),
              delivery_date: yup.string().optional().nullable(),
              delivery_date_t: yup.string().optional().nullable(),
              container_drop_location: yup.string().optional().nullable(),
              storage_expiration: yup.string().optional().nullable(),
              storage_expiration_t: yup.string().optional().nullable(),
              container_type: yup.string().optional().nullable(),
              container_type_id: yup.number().optional().nullable(),
              container_seal_no: yup.number().optional().nullable(),
              yard_id: yup.number().optional().nullable(),
              shipping_line_id: yup.number().optional().nullable(),
              cha_id: yup.number().optional().nullable(),
              demurrage_expiration: yup.string().optional().nullable(),
              demurrage_expiration_t: yup.string().optional().nullable(),
              ata_date: yup.string().optional().nullable().required("required"),
              proposed_freight_rate: yup.number().nullable().optional(),
              actual_freight_rate: yup.number().nullable().optional(),
              final_freight_rate: yup.number().nullable().optional(),
              final_rate: yup.number().nullable().optional(),
              uom: yup.string().nullable().optional(),
              CFTKGFactor: yup.number().nullable().optional(),
              contractual_customer_id : FEATURES.contractualCustomerFieldEnabled ? yup
              .string()
              .optional()
              .nullable()
              .when("customer_type_id", (customer_type_id) =>
              customer_type_id && customer_type_id == 2
                  ? yup.string().required("Required").nullable()
                  : yup.string().optional().nullable()
                ) : yup
                    .string()
                    .optional()
                    .nullable(),
              products: yup.array().of(
                yup.object().shape({
                  product_code: yup.string().optional().nullable(),
                  product_name: yup.string().optional().nullable(),
                  product_category_id: yup.number().optional().nullable(),
                  product_category_name: yup.string().optional().nullable(),
                  packaging_type_id: yup.number().optional().nullable(),
                  quantity: yup.number().optional().min(1, "min").nullable(),
                })
              ),
              invoices: yup.array().of(
                yup.object().shape({
                  invoice_code: yup.string().optional().nullable(),
                  invoice_date: yup.string().optional().nullable(),
                  invoice_quantity: yup
                    .number()
                    .optional()
                    .nullable(),
                  invoice_amount: yup.number().optional().nullable(),
                  eway_bill_expirydate: yup.string().optional().nullable(),
                  eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
                })
              ),
            },
            ["max_temp", "min_temp"]
          )
        ),
      });
    } else {
      var validationSchema = yup.object().shape({
        deliveries: yup.array().of(
          yup.object().shape(
            {
              delivery_number: yup.string().optional(),
              delivery_reference_no: yup.string().nullable().optional(),
              booking_branch_id: yup.number().nullable().optional(),
              billing_branch_id: yup.number().nullable().optional(),
              lr_no: yup.string().nullable().optional(),
              lr_date: yup.string().nullable().optional(),
              lr_date_t: yup.string().nullable().optional(),
              actual_weight: yup.number().nullable().optional(),
              gross_weight: yup.number().nullable().optional(),
              charged_weight: yup.number().nullable().optional(),
              total_quantity: yup.number().nullable().optional(),
              customer_type_id: yup.number().nullable().optional(),
              billing_party_id:
                localStorage.getItem("customerNumber") == 1183
                  ? yup.string().nullable().required("Required")
                  : yup.number().nullable().optional(),
              billing_party_branch_id:
                localStorage.getItem("customerNumber") == 1183
                  ? yup.string().nullable().required("Required")
                  : yup.number().nullable().optional(),
              deliver_to: yup.string().nullable().optional(),
              deliver_to_branch_id: yup.number().nullable().optional(),
              deliver_to_address: yup.string().nullable().optional(),
              other: yup.string().nullable().optional(),
              consignor_code: yup.string().required("required"),
              consignee_code: yup.string().required("required"),
              consignee_address: yup.string().nullable().optional(),
              consignor_address: yup.string().nullable().optional(),
              consignor_gstNumber: yup.string().nullable().optional(),
              consignee_gstNumber: yup.string().nullable().optional(),
              boarding_no: yup.string().optional().nullable(),
              import_declaration_no: yup.string().optional().nullable(),
              do_no: yup.string().nullable().optional(),
              do_validity_date: yup.string().nullable().optional(),
              do_validity_date_t: yup.string().nullable().optional(),
              proposed_freight_rate: yup.number().nullable().optional(),
              actual_freight_rate: yup.number().nullable().optional(),
              final_freight_rate: yup.number().nullable().optional(),
              final_rate: yup.number().nullable().optional(),
              uom: yup.string().nullable().optional(),
              CFTKGFactor: yup.number().nullable().optional(),
              min_temp: yup
                .number()
                .optional()
                .nullable()
                .when("max_temp", (max_temp) =>
                  max_temp
                    ? yup.number().optional().nullable().max(max_temp, "max")
                    : yup.number().optional().nullable()
                ),
              max_temp: yup
                .number()
                .optional()
                .nullable()
                .when("min_temp", (min_temp) =>
                  min_temp
                    ? yup.number().optional().nullable().min(min_temp, "min")
                    : yup.number().optional().nullable()
                ),
              container_no: yup.string().optional().nullable(),
              container_pickup_date: yup.string().optional().nullable(),
              container_pickup_date_t: yup.string().optional().nullable(),
              delivery_date: yup.string().optional().nullable(),
              delivery_date_t: yup.string().optional().nullable(),
              container_drop_location: yup.string().optional().nullable(),
              storage_expiration: yup.string().optional().nullable(),
              container_type: yup.string().optional().nullable(),
              container_type_id: yup.number().optional().nullable(),
              container_seal_no: yup.number().optional().nullable(),
              yard_id: yup.number().optional().nullable(),
              shipping_line_id: yup.number().optional().nullable(),
              cha_id: yup.number().optional().nullable(),
              demurrage_expiration: yup.string().optional().nullable(),
              ata_date: yup.string().optional().nullable(),
              contractual_customer_id : FEATURES.contractualCustomerFieldEnabled ? yup
              .string()
              .optional()
              .nullable()
              .when("customer_type_id", (customer_type_id) =>
              customer_type_id && customer_type_id == 2
                  ? yup.string().required("Required").nullable()
                  : yup.string().optional().nullable()
                ) : yup
                    .string()
                    .optional()
                    .nullable(),
              products: yup.array().of(
                yup.object().shape({
                  product_code: yup.string().optional().nullable(),
                  product_name: yup.string().optional().nullable(),
                  product_category_id: yup.number().optional().nullable(),
                  product_category_name: yup.string().optional().nullable(),
                  packaging_type_id: yup.number().optional().nullable(),
                  quantity: yup.number().optional().min(1, "min").nullable(),
                  // quantity: yup.number().required("required").min(1, "min"),
                })
              ),
              invoices: yup.array().of(
                yup.object().shape({
                  invoice_code: yup.string().optional().nullable(),
                  invoice_date: yup.string().optional().nullable(),
                  invoice_quantity: yup
                    .number()
                    .optional()
                    .nullable(),
                  invoice_amount: yup.number().optional().nullable(),
                  eway_bill_expirydate: yup.string().optional().nullable(),
                  eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
                })
              ),
            },
            ["max_temp", "min_temp"]
          )
        ),
      });
    }
  } else {
    if (props.movement_type == "import") {
      var validationSchema = yup.object().shape(
        {
          // order_number: yup.string().optional(),
          order_reference_no: yup.string().nullable().optional(),
          gross_weight: yup
            .number()
            .required("required")
            .min(1, "min")
            .when("net_weight", (net_weight) =>
              net_weight
                ? yup.number().optional().nullable().min(net_weight, "min_net")
                : yup.number().required("required").min(1, "min")
            ),
          net_weight: yup
            .number()
            .required("required")
            .min(1, "min")
            .when("gross_weight", (gross_weight) =>
              gross_weight
                ? yup
                  .number()
                  .optional()
                  .nullable()
                  .max(gross_weight, "max_gross")
                : yup.number().required("required").min(1, "min")
            ),
          //proposed_vehicle_type: yup.number().required("required"),
          //ownership_type_id: yup.number().optional().nullable(),
          //booking_branch_id: yup.number().optional().nullable(),
          //vehicle_number: yup.string().optional().nullable(),
          vendor_id: yup.number().optional(),
          freight_rate: yup.number().optional(),
          service_type_id: yup.number().optional(),
          load_type_id: yup.number().optional(),
          deliveries: yup.array().of(
            yup.object().shape(
              {
                delivery_number: yup.string().optional(),
                delivery_reference_no: yup.string().nullable().optional(),
                booking_branch_id: yup.number().nullable().optional(),
                billing_branch_id: yup.number().nullable().optional(),
                lr_no: yup.string().nullable().optional(),
                lr_date: yup.string().nullable().optional(),
                lr_date_t: yup.string().nullable().optional(),
                actual_weight: yup.number().nullable().optional(),
                gross_weight: yup.number().nullable().optional(),
                charged_weight: yup.number().nullable().optional(),
                total_quantity: yup.number().nullable().optional(),
                customer_type_id: yup.number().nullable().optional(),
                billing_party_id: yup.number().nullable().optional(),
                billing_party_branch_id: yup.number().nullable().optional(),
                deliver_to: yup.string().nullable().optional(),
                deliver_to_branch_id: yup.number().nullable().optional(),
                deliver_to_address: yup.string().nullable().optional(),
                other: yup.string().nullable().optional(),
                consignor_code: yup.string().required("required"),
                consignee_code: yup.string().required("required"),
                consignee_address: yup.string().nullable().optional(),
                consignor_address: yup.string().nullable().optional(),
                consignor_gstNumber: yup.string().nullable().optional(),
                consignee_gstNumber: yup.string().nullable().optional(),
                boarding_no: yup.string().optional().nullable(),
                import_declaration_no: yup.string().optional().nullable(),
                do_no: yup.string().nullable().optional(),
                do_validity_date: yup.string().nullable().optional(),
                do_validity_date_t: yup.string().nullable().optional(),
                min_temp: yup
                  .number()
                  .optional()
                  .nullable()
                  .when("max_temp", (max_temp) =>
                    max_temp
                      ? yup.number().optional().nullable().max(max_temp, "max")
                      : yup.number().optional().nullable()
                  ),
                max_temp: yup
                  .number()
                  .optional()
                  .nullable()
                  .when("min_temp", (min_temp) =>
                    min_temp
                      ? yup.number().optional().nullable().min(min_temp, "min")
                      : yup.number().optional().nullable()
                  ),
                container_no: yup.string().optional().nullable(),
                container_pickup_date: yup.string().optional().nullable(),
                container_pickup_date_t: yup.string().optional().nullable(),
                delivery_date: yup.string().optional().nullable(),
                delivery_date_t: yup.string().optional().nullable(),
                container_drop_location: yup.string().optional().nullable(),
                storage_expiration: yup.string().optional().nullable(),
                storage_expiration_t: yup.string().optional().nullable(),
                container_type: yup.string().optional().nullable(),
                container_type_id: yup.number().optional().nullable(),
                container_seal_no: yup.number().optional().nullable(),
                yard_id: yup.number().optional().nullable(),
                shipping_line_id: yup.number().optional().nullable(),
                cha_id: yup.number().optional().nullable(),
                demurrage_expiration: yup.string().optional().nullable(),
                demurrage_expiration_t: yup.string().optional().nullable(),
                ata_date: yup
                  .string()
                  .optional()
                  .nullable()
                  .required("required"),
                proposed_freight_rate: yup.number().nullable().optional(),
                actual_freight_rate: yup.number().nullable().optional(),
                final_freight_rate: yup.number().nullable().optional(),
                final_rate: yup.number().nullable().optional(),
                uom: yup.string().nullable().optional(),
                CFTKGFactor: yup.number().nullable().optional(),
                contractual_customer_id :FEATURES.contractualCustomerFieldEnabled ? yup
                .string()
                .optional()
                .nullable()
                .when("customer_type_id", (customer_type_id) =>
                customer_type_id && customer_type_id == 2
                    ? yup.string().required("Required").nullable()
                    : yup.string().optional().nullable()
                  ) : yup
                      .string()
                      .optional()
                      .nullable(),
                products: yup.array().of(
                  yup.object().shape({
                    product_code: yup.string().optional().nullable(),
                    product_name: yup.string().optional().nullable(),
                    product_category_id: yup.number().optional().nullable(),
                    product_category_name: yup.string().optional().nullable(),
                    packaging_type_id: yup.number().optional().nullable(),
                    quantity: yup.number().optional().min(1, "min").nullable(),
                  })
                ),
                invoices: yup.array().of(
                  yup.object().shape({
                    invoice_code: yup.string().optional().nullable(),
                    invoice_date: yup.string().optional().nullable(),
                    invoice_quantity: yup
                      .number()
                      .optional()
                      .nullable(),
                    invoice_amount: yup.number().optional().nullable(),
                    eway_bill_expirydate: yup.string().optional().nullable(),
                    eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
                  })
                ),
              },
              ["max_temp", "min_temp"]
            )
          ),
        },
        ["net_weight", "gross_weight"]
      );
    } else {
      var validationSchema = yup.object().shape(
        {
          /* order_reference_no: yup.string().nullable().optional(),
          gross_weight: yup
            .number()
            .required("required")
            .min(1, "min")
            .when("net_weight", (net_weight) =>
              net_weight
                ? yup.number().optional().nullable().min(net_weight, "min_net")
                : yup.number().required("required").min(1, "min")
            ),
          net_weight: yup
            .number()
            .required("required")
            .min(1, "min")
            .when("gross_weight", (gross_weight) =>
              gross_weight
                ? yup
                  .number()
                  .optional()
                  .nullable()
                  .max(gross_weight, "max_gross")
                : yup.number().required("required").min(1, "min")
            ),
          proposed_vehicle_type: yup.number().required("required"),
          ownership_type_id: yup.number().optional().nullable(), */
          booking_branch_id: yup.number().optional().nullable(),
          vendor_id: yup.number().optional(),
          ownership_type_id: yup.number().optional(),
          freight_rate: yup.number().optional(),
          service_type_id: yup.number().optional(),
          load_type_id: yup.number().optional(),
          deliveries: yup.array().of(
            yup.object().shape(
              {
                delivery_number: yup.string().optional(),
                delivery_reference_no: yup.string().nullable().optional(),
                booking_branch_id: yup.number().nullable().optional(),
                billing_branch_id: yup.number().nullable().optional(),
                lr_no: yup.string().nullable().optional(),
                lr_date: yup.string().nullable().optional(),
                lr_date_t: yup.string().nullable().optional(),
                actual_weight: yup.number().nullable().optional(),
                gross_weight: yup.number().nullable().optional(),
                charged_weight: yup.number().nullable().optional(),
                total_quantity: yup.number().nullable().optional(),
                customer_type_id: yup.number().nullable().optional(),
                billing_party_id:
                  localStorage.getItem("customerNumber") == 1183
                    ? yup.string().nullable().required("Required")
                    : yup.number().nullable().optional(),
                billing_party_branch_id:
                  localStorage.getItem("customerNumber") == 1183
                    ? yup.string().nullable().required("Required")
                    : yup.number().nullable().optional(),
                deliver_to: yup.string().nullable().optional(),
                deliver_to_branch_id: yup.number().nullable().optional(),
                deliver_to_address: yup.string().nullable().optional(),
                other: yup.string().nullable().optional(),
                consignor_code: yup.string().required("required"),
                consignee_code: yup.string().required("required"),
                consignee_address: yup.string().nullable().optional(),
                consignor_address: yup.string().nullable().optional(),
                consignor_gstNumber: yup.string().nullable().optional(),
                consignee_gstNumber: yup.string().nullable().optional(),
                boarding_no: yup.string().optional().nullable(),
                import_declaration_no: yup.string().optional().nullable(),
                do_no: yup.string().nullable().optional(),
                do_validity_date: yup.string().nullable().optional(),
                do_validity_date_t: yup.string().nullable().optional(),
                proposed_freight_rate: yup.number().nullable().optional(),
                actual_freight_rate: yup.number().nullable().optional(),
                final_freight_rate: yup.number().nullable().optional(),
                final_rate: yup.number().nullable().optional(),
                uom: yup.string().nullable().optional(),
                CFTKGFactor: yup.number().nullable().optional(),
                min_temp: yup
                  .number()
                  .optional()
                  .nullable()
                  .when("max_temp", (max_temp) =>
                    max_temp
                      ? yup.number().optional().nullable().max(max_temp, "max")
                      : yup.number().optional().nullable()
                  ),
                max_temp: yup
                  .number()
                  .optional()
                  .nullable()
                  .when("min_temp", (min_temp) =>
                    min_temp
                      ? yup.number().optional().nullable().min(min_temp, "min")
                      : yup.number().optional().nullable()
                  ),
                container_no: yup.string().optional().nullable(),
                container_pickup_date: yup.string().optional().nullable(),
                container_pickup_date_t: yup.string().optional().nullable(),
                delivery_date: yup.string().optional().nullable(),
                delivery_date_t: yup.string().optional().nullable(),
                container_drop_location: yup.string().optional().nullable(),
                storage_expiration: yup.string().optional().nullable(),
                container_type: yup.string().optional().nullable(),
                container_type_id: yup.number().optional().nullable(),
                container_seal_no: yup.string().optional().nullable(),
                yard_id: yup.number().optional().nullable(),
                shipping_line_id: yup.number().optional().nullable(),
                cha_id: yup.number().optional().nullable(),
                demurrage_expiration: yup.string().optional().nullable(),
                ata_date: yup.string().optional().nullable(),
                contractual_customer_id : FEATURES.contractualCustomerFieldEnabled ? yup
                .string()
                .optional()
                .nullable()
                .when("customer_type_id", (customer_type_id) =>
                customer_type_id && customer_type_id == 2
                    ? yup.string().required("Required").nullable()
                    : yup.string().optional().nullable()
                  ) : yup
                      .string()
                      .optional()
                      .nullable(),
                products: yup.array().of(
                  yup.object().shape({
                    product_code: yup.string().optional().nullable(),
                    product_name: yup.string().optional().nullable(),
                    product_category_id: yup.number().optional().nullable(),
                    product_category_name: yup.string().optional().nullable(),
                    packaging_type_id: yup.number().optional().nullable(),
                    quantity: yup.number().optional().min(1, "min").nullable(),
                    // quantity: yup.number().required("required").min(1, "min"),
                  })
                ),
                invoices: yup.array().of(
                  yup.object().shape({
                    invoice_code: yup.string().optional().nullable(),
                    invoice_date: yup.string().optional().nullable(),
                    invoice_quantity: yup
                      .number()
                      .optional()
                      .nullable(),
                    invoice_amount: yup.number().optional().nullable(),
                    eway_bill_expirydate: yup.string().optional().nullable(),
                    eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
                  })
                ),
              },
              ["max_temp", "min_temp"]
            )
          ),
        },
        ["net_weight", "gross_weight"]
      );
    }
  }

  const getBillingPartySelected = (billingPartyId) => {

    if (billingPartyId) {
      let token = localStorage.getItem("isloggedIn");
      let userId = localStorage.getItem("userId");
      let customerNo = localStorage.getItem("customerNumber");
      let billingPartyBranchIds = localStorage
        .getItem("billingpartbranchIds")
        .toString();

      if (
        localStorage.getItem("customerNumber") === "503 " ||
        "1360 " ||
        "549" ||
        "353"
      ) {
        ReadMasterAxios({
          completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping?${billingPartyId}`,
          mainUserId: Number(localStorage.getItem("userId")),
          billingPartyId: billingPartyId,
        })
          .then((res) => {
            let ownership = res.data.resultSet[0].paymentType;
            setcustomertype(
              ownership.map((item, index) => {
                return {
                  key: index,
                  value: item.id,
                  text: item.name,
                  raw: { ...item },
                };
              })
            );
          })
          .catch((err) => { });
      }

      Axios.get(
        `${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchIds=${billingPartyBranchIds}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          setBillingPartyBranch(response.data.resultSet);
        })
        .catch((error) => console.log(error));
    } else {
      setBillingPartyBranch([]);
    }
  };

  const getConsigneeConsignorArray = (billingPartyId, billingPartyBranchId) => {
    let token = localStorage.getItem("isloggedIn");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNumber");

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}mappings/consignor_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchId=${billingPartyBranchId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setConsignorArray(response.data.resultSet);
      })
      .catch((error) => console.log(error));

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}mappings/consignee_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchId=${billingPartyBranchId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setConsigneeArray(response.data.resultSet);
      })
      .catch((error) => console.log(error));
  };

  const generateInitialValues = () => {
    if (props?.deliveryDataFetch) {
      if(props?.deliveryDataFetch?.booking_branch_id && props?.deliveryDataFetch?.lr_no ){
        let index=0
        let lr_numbers = lrNumbers
        lrNumbers[index]= lrNumbers[index] || {}
        lr_numbers[index][props?.deliveryDataFetch?.booking_branch_id] = lr_numbers[index][props?.deliveryDataFetch?.booking_branch_id] || {}
        lr_numbers[index][props?.deliveryDataFetch?.booking_branch_id].defaultLR = props?.deliveryDataFetch?.lr_no
        setLrNumbers(lr_numbers)
      }

      const invoices = []
      props?.deliveryDataFetch?.invoices?.length > 0 ?
      props?.deliveryDataFetch?.invoices.map((invoice)=>{
        invoices.push({
          boe_date: invoice.boe_date
            ? moment(
              invoice.boe_date,
              "YYYY-MM-DD HH:mm"
            )
            : null,

          boe_no: invoice.boe_no
            ? invoice.boe_no
            : null,

          tracking_number: invoice
            ?.tracking_number
            ? invoice.tracking_number
            : null,

          invoice_id: invoice.id
            ? invoice.id
            : null,

          invoice_no: invoice.invoice_no
            ? invoice.invoice_no
            : null, //invoice_no

          invoice_reference_no: invoice.invoice_reference_no
            ? invoice.invoice_reference_no
            : null, //invoice_no


          invoice_date: invoice.invoice_date
            ?
            invoice.invoice_date
            : null,
          eway_bill_no: invoice.eway_bill_no
            ? invoice.eway_bill_no
            : null, //invoice_no

          eway_bill_expirydate: invoice?.eway_bill_expirydate?
          invoice.eway_bill_expirydate
            : null,

          invoice_quantity:
            invoice.invoice_quantity
              ?  Number(invoice.invoice_quantity)
              : null,
          invoice_amount:
            invoice.invoice_amount
              ?  Number(invoice.invoice_amount)
              : null,
          bl_no: invoice.bl_no
            ? invoice.bl_no
            : null,
        })
      }) 
        :
        invoices.push({
          boe_date: null,

          boe_no: null,

          tracking_number: null,

          invoice_id: null,

          invoice_no: null, //invoice_no
          invoice_reference_no : null ,

          invoice_date: null,
          eway_bill_no: null, //invoice_no

          eway_bill_expirydate: null,

          invoice_quantity: null,
          invoice_amount: null,
          bl_no: null,
        })


      return {
        // order_number: "",
        order_reference_no: props?.getCurrentOrderDetails?.order_reference_no
          ? props.getCurrentOrderDetails.order_reference_no
          : null,

        gross_weight: props?.getCurrentOrderDetails?.gross_weight
          ? props.getCurrentOrderDetails.gross_weight
          : null,

        net_weight: props?.getCurrentOrderDetails?.net_weight
          ? props.getCurrentOrderDetails.net_weight
          : null,

        proposed_vehicle_type: props?.getCurrentOrderDetails
          ?.proposed_vehicle_type
          ? props.getCurrentOrderDetails.proposed_vehicle_type
          : "",

        ownership_type_id: 2,
        proposed_vehicle_type_name: "",

        vendor_id: props?.getCurrentOrderDetails?.vendor_id
          ? props.getCurrentOrderDetails.vendor_id
          : null, //undefined,

        vendor_name: "",
        vehicle_number: "",
        booking_branch_id: null,
        booking_branch_name: "",

        freight_rate: props?.getCurrentOrderDetails?.freight_rate
          ? props.getCurrentOrderDetails.freight_rate
          : null,

        service_type_id: props?.getCurrentOrderDetails?.service_type_id
          ? props.getCurrentOrderDetails.service_type_id
          : null,

        load_type_id: props?.getCurrentOrderDetails?.load_type_id
          ? props.getCurrentOrderDetails.load_type_id
          : null, //4,

        movement_type: props?.deliveryDataFetch?.movement_type
          ? props.deliveryDataFetch.movement_type
          : null,

        deliveries: [
          {
            delivery_number: props?.deliveryDataFetch?.delivery_no
              ? props.deliveryDataFetch.delivery_no
              : null,

            delivery_reference_no: props?.deliveryDataFetch
              ?.delivery_reference_no
              ? props.deliveryDataFetch.delivery_reference_no
              : null,

            lr_no: props?.deliveryDataFetch?.lr_no
              ? props.deliveryDataFetch.lr_no
              : null,

            is_lr_generated_by_lr_series: props?.deliveryDataFetch?.is_lr_generated_by_lr_series
              ? props.deliveryDataFetch.is_lr_generated_by_lr_series
              : false,

            lr_date: props.reqon,

            lr_date_t: props.reqon,

            actual_weight: props?.deliveryDataFetch?.actual_weight
              ? props.deliveryDataFetch.actual_weight
              : null,

            gross_weight: props?.deliveryDataFetch?.gross_weight
              ? props.deliveryDataFetch.gross_weight
              : null,

            remarks: props?.deliveryDataFetch?.remarks
              ? props.deliveryDataFetch.remarks
              : null,

            charged_weight: Number(
              props?.deliveryDataFetch?.charged_weight
                ? props.deliveryDataFetch.charged_weight
                : null
            ),

            total_quantity: Number(
              props?.deliveryDataFetch?.total_quantity
                ? props.deliveryDataFetch.total_quantity
                : null
            ),

            customer_type_id: props?.deliveryDataFetch?.customer_type_id
              ? props.deliveryDataFetch.customer_type_id
              : null,

            customer_type_name: props?.deliveryDataFetch?.customer_type_name
              ? props.deliveryDataFetch.customer_type_name
              : null,

            sales_person_id: props?.deliveryDataFetch?.sales_person_id
              ? props.deliveryDataFetch.sales_person_id
              : null,

            contractual_customer_id: props?.deliveryDataFetch?.contractual_customer_id
              ? props.deliveryDataFetch.contractual_customer_id
              : null,

            billing_party_id: props?.deliveryDataFetch?.billing_party_id
              ? props.deliveryDataFetch.billing_party_id
              : null,

            billing_party_name: props?.deliveryDataFetch?.billing_party_name
              ? props.deliveryDataFetch.billing_party_name
              : null,

            billing_party_branch_id: props?.deliveryDataFetch
              ?.billing_party_branch_id
              ? props.deliveryDataFetch.billing_party_branch_id
              : null,

            billing_party_branch_name: props?.deliveryDataFetch
              ?.billing_party_branch_name
              ? props.deliveryDataFetch.billing_party_branch_name
              : null,

            booking_branch_id: props?.deliveryDataFetch?.booking_branch_id
              ? props.deliveryDataFetch.booking_branch_id
              : null,

            booking_branch_name: props?.deliveryDataFetch?.booking_branch_name
              ? props.deliveryDataFetch.booking_branch_name
              : null,

            billing_branch_id: props?.deliveryDataFetch?.billing_branch_id
              ? props.deliveryDataFetch.billing_branch_id
              : null,

            billing_branch_name: props?.deliveryDataFetch?.billing_branch_name
              ? props.deliveryDataFetch.billing_branch_name
              : null,

            deliver_to: props?.deliveryDataFetch?.deliver_to
              ? props.deliveryDataFetch.deliver_to
              : null, //"consignee",

            deliver_to_branch_id: null,

            deliver_to_address: props?.deliveryDataFetch?.deliver_to_address
              ? props.deliveryDataFetch.deliver_to_address
              : null,

            other: null,

            consignor_code: props?.deliveryDataFetch?.consignor?.consignorCode
              ? props.deliveryDataFetch.consignor.consignorCode
              : "",

            consignor_name: props?.deliveryDataFetch?.consignor?.name
              ? props.deliveryDataFetch.consignor.name
              : "",


            consignor_address: props?.deliveryDataFetch?.consignor
              ?.consignor_address
              ? props.deliveryDataFetch.consignor.consignor_address
              : "",

            consignor_gstNumber: props?.deliveryDataFetch?.consignor?.gst_number
              ? props.deliveryDataFetch.consignor.gst_number
              : "",

            //consignee_address: ""
            //consignee_code: ""
            //consignee_gstNumber: ""
            //consignee_name: ""

            consignee_code: props?.deliveryDataFetch?.consignee?.consigneeCode
              ? props.deliveryDataFetch.consignee.consigneeCode
              : "",
            consignee_name: props?.deliveryDataFetch?.consignee?.name
              ? props.deliveryDataFetch.consignee.name
              : "",
            consignee_address: props?.deliveryDataFetch?.consignee
              ?.consignee_address
              ? props.deliveryDataFetch.consignee.consignee_address
              : "",
            consignee_gstNumber: props?.deliveryDataFetch?.consignee?.gst_number
              ? props.deliveryDataFetch.consignee.gst_number
              : "",

            pickup_area: props?.deliveryDataFetch?.pickup_area
              ? props.deliveryDataFetch.pickup_area
              : null,

            drop_area: props?.deliveryDataFetch?.drop_area
              ? props.deliveryDataFetch.drop_area
              : null,

            min_temp: props?.deliveryDataFetch?.min_temp
              ? props.deliveryDataFetch.min_temp
              : null,

            max_temp: props?.deliveryDataFetch?.max_temp
              ? props.deliveryDataFetch.max_temp
              : null,

            container_no: props?.deliveryDataFetch?.container_no
              ? props.deliveryDataFetch.container_no
              : null,

            container_pickup_date: props.reqon,

            container_pickup_date_t: props.reqon,

            delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),

            delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),

            container_drop_location: props?.deliveryDataFetch?.drop_location
              ? props.deliveryDataFetch.drop_location
              : null,

            storage_expiration_date: null, //storage_expiration_date

            storage_expiration_date_t: null,

            container_type: props?.deliveryDataFetch?.container_type
              ? props.deliveryDataFetch.container_type
              : null,

            container_type_id: props?.deliveryDataFetch?.container_type_id
              ? props.deliveryDataFetch.container_type_id
              : null,

            container_seal_no: props?.deliveryDataFetch?.container_seal_no
              ? props.deliveryDataFetch.container_seal_no
              : null,

            yard_id: props?.deliveryDataFetch?.yard_id
              ? props.deliveryDataFetch.yard_id
              : null,

            shipping_line_id: props?.deliveryDataFetch?.shipping_line_id
              ? props.deliveryDataFetch.shipping_line_id
              : null,

            cha_id: props?.deliveryDataFetch?.cha_id
              ? props.deliveryDataFetch.cha_id
              : null,

            demurrage_expiration_date: null, //demurrage_expiration_date

            demurrage_expiration_date_t: null,

            ata_date: null, //ata_date

            ata_date_t: null,

            boarding_no: props?.deliveryDataFetch?.boarding_no
              ? props.deliveryDataFetch.boarding_no
              : null,

            import_declaration_no: props?.deliveryDataFetch
              ?.import_declaration_no
              ? props.deliveryDataFetch.import_declaration_no
              : null,

            do_no: props?.deliveryDataFetch?.do_no
              ? props.deliveryDataFetch.do_no
              : null,

            do_validity_date: null, //do_validity_date

            do_validity_date_t: null,

            proposed_freight_rate: props?.deliveryDataFetch
              ?.proposed_freight_rate
              ? props.deliveryDataFetch.proposed_freight_rate
              : null,

            actual_freight_rate: props?.deliveryDataFetch?.actual_freight_rate
              ? props.deliveryDataFetch.actual_freight_rate
              : null,

            final_freight_rate: props?.deliveryDataFetch?.final_freight_rate
              ? props.deliveryDataFetch.final_freight_rate
              : null,

            final_rate: props?.deliveryDataFetch?.final_rate
              ? props.deliveryDataFetch.final_rate
              : null,

            uom: props?.deliveryDataFetch?.uom
              ? props.deliveryDataFetch.uom
              : null, //"ton",

            CFTKGFactor: props?.CFTKGFactor
              ?.CFTKGFactor
              ? props.deliveryDataFetch.CFTKGFactor
              : null,

            products: [
              {
                product_id: props?.deliveryDataFetch?.products?.[0]?.product_id
                  ? props.deliveryDataFetch.products[0].product_id
                  : null,
                product_code: props?.deliveryDataFetch?.products?.[0]?.sku
                  ?.product_code
                  ? props.deliveryDataFetch.products[0].sku.product_code
                  : null, //

                product_name: props?.deliveryDataFetch?.products?.[0]?.sku
                  ?.product_name
                  ? props.deliveryDataFetch.products[0].sku.product_name
                  : null, //

                quantity: props?.deliveryDataFetch?.products?.[0]?.quantity
                  ? props.deliveryDataFetch.products[0].quantity
                  : null,

                product_category_id: props?.deliveryDataFetch?.products?.[0]
                  ?.product_category_id
                  ? props.deliveryDataFetch.products[0].product_category_id
                  : null,

                  product_category_name: props?.deliveryDataFetch?.products?.[0]
                  ?.product_category_name
                  ? props.deliveryDataFetch.products[0].product_category_name
                  : null,

                packaging_type_id: props?.deliveryDataFetch?.products?.[0]
                  ?.packaging_type_id
                  ? props.deliveryDataFetch.products[0].packaging_type_id
                  : null,

                invoice_no: props?.deliveryDataFetch?.products?.[0]?.invoice_no
                  ? props.deliveryDataFetch.products[0].invoice_no
                  : null,

                length: props?.deliveryDataFetch?.products?.[0]?.length
                  ? props.deliveryDataFetch.products[0].length
                  : null,

                breadth: props?.deliveryDataFetch?.products?.[0]?.breadth
                  ? props.deliveryDataFetch.products[0].breadth
                  : null,

                height: props?.deliveryDataFetch?.products?.[0]?.height
                  ? props.deliveryDataFetch.products[0].height
                  : null,
              },
            ],




            invoices: invoices,
            lr_other_charges: props?.deliveryDataFetch?.lr_other_charges ? props.deliveryDataFetch.lr_other_charges : []            
          },
        ],
      };
    } else {
      return {
        // order_number: "",
        order_reference_no: "null",
        gross_weight: 1,
        net_weight: 1,
        proposed_vehicle_type: "",
        ownership_type_id: 2,
        proposed_vehicle_type_name: "",
        vendor_id: undefined,
        vendor_name: "",
        vehicle_number: "",
        booking_branch_id: null,
        booking_branch_name: "",
        freight_rate: "0",
        service_type_id: props?.getCurrentOrderDetails?.service_type_id
          ? props.getCurrentOrderDetails.service_type_id
          : null,
        load_type_id: 4,
        deliveries: [
          {
            delivery_number: "",
            delivery_reference_no: null,
            lr_no: null,
            is_lr_generated_by_lr_series : false,
            lr_date: props.reqon,
            lr_date_t: props.reqon,
            actual_weight: null,
            gross_weight: null,
            remarks: null,
            charged_weight: 0, //null,
            total_quantity: 0, //null,
            customer_type_id: null,
            customer_type_name: null,
            billing_party_id: null,
            billing_party_branch_id: null,
            billing_party_branch_name: "",
            booking_branch_id: null,
            booking_branch_name: "",
            billing_branch_id: null,
            billing_branch_name: "",
            deliver_to: "consignee",
            deliver_to_branch_id: null,
            deliver_to_address: null,
            other: null,
            consignor_code: "",
            consignor_name: "",
            consignor_address: "",
            consignor_gstNumber: "",

            //consignee_address: ""
            //consignee_code: ""
            //consignee_gstNumber: ""
            //consignee_name: ""

            consignee_code: "",
            consignee_name: "",
            consignee_address: "",
            consignee_gstNumber: "",

            min_temp: null,
            max_temp: null,
            container_no: null,
            container_pickup_date: props.reqon,
            container_pickup_date_t: props.reqon,
            delivery_date: moment(props.reqon).add(props.btime, "h").toDate(),
            delivery_date_t: moment(props.reqon).add(props.btime, "h").toDate(),
            container_drop_location: null,
            storage_expiration_date: null,
            storage_expiration_date_t: null,
            container_type: null,
            container_type_id: null,
            container_seal_no: "",
            yard_id: null,
            shipping_line_id: null,
            cha_id: null,
            demurrage_expiration_date: null,
            demurrage_expiration_date_t: null,
            ata_date: null,
            ata_date_t: null,
            boarding_no: null,
            import_declaration_no: null,
            do_no: null,
            do_validity_date: null,
            do_validity_date_t: null,
            proposed_freight_rate: 0,
            actual_freight_rate: 0,
            final_freight_rate: 0,
            final_rate: 0,
            uom: "ton",
            CFTKGFactor: 0,
            products: [
              {
                product_code: null,
                product_name: null,
                quantity: null,
                product_category_id: null,
                product_category_name: null,
                packaging_type_id: null,
                invoice_no: null,
                length: 0,
                breadth: 0,
                height: 0,
              },
            ],
            invoices: [
              {
                invoice_no: null,
                invoice_reference_no :null,
                invoice_date: null,
                invoice_quantity: null, //null,
                invoice_amount: null, //null,
                bl_no: null,
                eway_bill_no: null,
                eway_bill_expirydate: null
              },
            ],
            lr_other_charges: [
              {
                charge_type_id: null,
                charges: null,
              }
            ]
          },
        ],
      };
    }
  };

  return (
    <div>
      <Modal
        open={props.OpenModel}
        size="fullscreen"
        centered={false}
        scrolling="true"
        onClose={props.handleClose}
      >
        <Modal.Header className="p-bold-100">
          {"Add Delivery Details"}
        </Modal.Header>
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={initalValue}
          onSubmit={(values) => {
            let orders = [];

            if (values.vendor_id == "") {
              values.vendor_id = 0;
            }
            if (values.deliveries.length > 1) {
              for (let index = 0; index < values.deliveries.length; index++) {
                if ((values.deliveries?.[index]?.lr_other_charges?.[0]?.charge_type_id == null || '') && (values.deliveries?.[index]?.lr_other_charges?.[0]?.charges == null || '')) {
                  values.deliveries[index].lr_other_charges = []
                }
                if (
                  orders[index].deliveries[index].invoices[0].bl_no == null &&
                  orders[index].deliveries[index].invoices[0].invoice_amount ==
                  null &&
                  orders[index].deliveries[index].invoices[0].invoice_date ==
                  null &&
                  orders[index].deliveries[index].invoices[0].eway_bill_no ==
                  null &&
                  orders[index].deliveries[index].invoices[0].eway_bill_expirydate ==
                  null &&
                  orders[index].deliveries[index].invoices[0].invoice_no ==
                  null &&
                  orders[index].deliveries[index].invoices[0]
                    .invoice_quantity == null &&
                  orders[index].deliveries[index].invoices[0].invoice_reference_no == null
                ) {
                  orders[index].deliveries[index].invoices = [];
                }
                if (
                  values.deliveries[index].products[0].product_code == null &&
                  values.deliveries[index].products[0].product_name == null &&
                  values.deliveries[index].products[0].product_category_id ==
                  null &&
                  values.deliveries[index].products[0].packaging_type_id ==
                  null &&
                  values.deliveries[index].products[0].quantity == null
                ) {
                  values.deliveries[index].products = [];
                }
              }
            }
            orders.push(values);
            for (let index = 0; index < orders.length; index++) {
              if (orders[index].deliveries[index].invoices.length != 0) {
                if (values?.deliveries[index]?.lr_other_charges[0]?.charge_type_id == null || '' && values?.deliveries[index]?.lr_other_charges[0]?.charges == null || '') {
                  values.deliveries[index].lr_other_charges = []
                }
                if (
                  orders[index].deliveries[index].invoices[0].bl_no == null &&
                  orders[index].deliveries[index].invoices[0].invoice_amount ==
                  null &&
                  orders[index].deliveries[index].invoices[0].invoice_date ==
                  null &&
                  orders[index].deliveries[index].invoices[0].eway_bill_no ==
                  null &&
                  orders[index].deliveries[index].invoices[0].eway_bill_expirydate ==
                  null &&
                  orders[index].deliveries[index].invoices[0].invoice_no ==
                  null &&
                  orders[index].deliveries[index].invoices[0]
                    .invoice_quantity == null &&
                  orders[index].deliveries[index].invoices[0].invoice_reference_no == null
                ) {
                  orders[index].deliveries[index].invoices = [];
                }
              }
            }
            for (let index = 0; index < orders.length; index++) {
              if (orders[index].deliveries[index].products.length > 0) {
                if ((values.deliveries?.[index]?.lr_other_charges?.[0]?.charge_type_id == null || '') && (values.deliveries?.[index]?.lr_other_charges?.[0]?.charges == null || '')) {
                  values.deliveries[index].lr_other_charges = []
                }
                if (
                  (orders[index].deliveries[index].products[0].product_code ==
                    null ||
                    orders[index].deliveries[index].products[0].product_code ==
                    "") &&
                  (orders[index].deliveries[index].products[0].product_name ==
                    null ||
                    orders[index].deliveries[index].products[0].product_name ==
                    "") &&
                  (orders[index].deliveries[index].products[0]
                    .product_category_id == null ||
                    orders[index].deliveries[index].products[0]
                      .product_category_id == "") &&
                  (orders[index].deliveries[index].products[0]
                    .packaging_type_id == null ||
                    orders[index].deliveries[index].products[0]
                      .packaging_type_id == "") &&
                  (orders[index].deliveries[index].products[0].quantity ==
                    null ||
                    orders[index].deliveries[index].products[0].quantity == "")
                ) {
                  orders[index].deliveries[index].products = [];
                }
              }
            }

            const passedElement = [];

            for (
              let index = 0;
              index < orders?.[0]?.deliveries.length;
              index++
            ) {
              let temp = orders?.[0]?.deliveries[index];
              temp.active = true;
              let consignor = {
                consignorCode: orders?.[0]?.deliveries[index].consignor_code,
                consignor_address:
                  orders?.[0]?.deliveries[index].consignor_address,
                consignor_city:
                  orders?.[0]?.deliveries[index].consignor_address,
                gst_number: orders?.[0]?.deliveries[index].consignor_gstNumber,
                id: orders?.[0]?.deliveries[index].consignor_code,
                name: orders?.[0]?.deliveries[index].consignor_name,
              };
              temp.consignor = consignor;
              temp.pickup_area = orders?.[0]?.deliveries[index].pickup_area;
              temp.drop_area = orders?.[0]?.deliveries[index].drop_area;
              let consignee = {
                consigneeCode: orders?.[0]?.deliveries[index].consignee_code,
                consignee_address:
                  orders?.[0]?.deliveries[index].consignee_address,
                consignee_city:
                  orders?.[0]?.deliveries[index].consignee_address,
                gst_number: orders?.[0]?.deliveries[index].consignee_gstNumber,
                id: orders?.[0]?.deliveries[index].consignee_code,
                name: orders?.[0]?.deliveries[index].consignee_name,
              };
              temp.consignee = consignee;
              if (props?.getCurrentOrderDetails) {
                temp.order_no = props.getCurrentOrderDetails.order_no;
                temp.order_reference_no =
                  props.getCurrentOrderDetails.order_reference_no;
                temp.vendor_order_id =
                  props.getCurrentOrderDetails.vendor_order_id;
              }

              temp.deliveryEditMode = true

              passedElement.push(temp);
              for (let index = 0; index < temp.products.length; index++) {
                const element = temp.products[index];
                element.sku = {
                  product_code: temp.products[index].product_code,
                  product_name: temp.products[index].product_name,
                };
              }
            }
            props.addDeliveryDetails(passedElement);
            props.handleClose();
          }}
          render={({ values, setFieldValue, errors, touched, t }) => {
            const setProductCodeAndProductName = (name, data, productname) => {
              setFieldValue(data.name, data.value);
              setFieldValue(
                productname,
                data.options.find((ele) => ele.value == data.value)
                  ? data.options.find((ele) => ele.value == data.value).raw
                    .skuName
                  : ""
              );
            };
            return (
              <Modal.Content
                size="fullscreen"
                style={{ maxHeight: "100%" }}
                scrolling={true}
              >
                <Modal.Description>
                  <Formiker className="ui form tiny">

                    {(props?.route_id == null || props?.route_id == undefined) ? (
                      <div className="form-row display-flex-center-justify-spacebtwn">
                        <div className="form-group col-4">
                          <div>
                            <label className="required-form-element">
                              {"Route"}
                            </label>
                          </div>
                          <div className="adjust-width-cell opacity-1">
                            <SearchDropdown
                              setField={(name, value) => {
                                setFieldValue("route_id", value?.raw?.routeMasterId ? value.raw.routeMasterId : "");
                                setFieldValue("route", value?.raw?.routeCode ? value.raw.routeCode : "");
                                setFieldValue("route_placeholder", value?.raw?.routeName ? value.raw.routeName : "");
                              }}
                              placeholder={values.route_placeholder}
                              masterRoute="routeMaster"
                              masterRouteKey="routeMasterId"
                              masterRouteName="routeName"
                              className="ui fliud input"
                              fieldName="route"
                              error={
                                touched.route &&
                                  errors.route
                                  ? true
                                  : false
                              }
                              blurMessage={"Please confirm route."}
                            />
                          </div>
                        </div>
                        <div className="form-group col-3"></div>
                        <div className="form-group col-4"></div>
                        <div className="form-group col-1"></div>
                      </div>
                    ) : null}


                    {props?.onlyDelivery ? (
                      <div className="form-row display-flex-center-justify-spacebtwn">
                        <div className="form-group col-4">
                          <div>
                            <label className="required-form-element">
                              {"Movement Type"}
                            </label>
                          </div>
                          <div className="adjust-width-cell opacity-1">
                            <Dropdown
                              name="movement_type"
                              disabled={props.mode == "view" ? true : false}
                              clearable
                              search
                              style={{ width: "100%" }}
                              selection
                              placeholder={""}
                              onChange={(name, data) => {
                                props.handleMovementType(data.value);
                                setFieldValue("movement_type", data.value);
                              }}
                              options={[
                                {
                                  key: "3",
                                  text: "Primary",
                                  value: "primary",
                                },
                                { key: "2", text: "Import", value: "import" },
                                { key: "4", text: "Export", value: "export" },
                              ]}
                              value={values.movement_type}
                            />
                          </div>
                        </div>
                        <div className="form-group col-3"></div>
                        <div className="form-group col-4"></div>
                        <div className="form-group col-1"></div>
                      </div>
                    ) : null}

                    <FieldArray name="deliveries"
                      render={(arrayHelpers) => (
                        <>
                          {values?.deliveries?.map((object, index) => (
                            <Table unstackable key={`delivery_form` + index}>
                              {/* <Formiker>
                                 <FormGroup>gu
                                  <FormField></FormField>
                                 </FormGroup>


                               </Formiker> */}
                              <Table.Header>
                                <Table.Row>
                                  <Table.HeaderCell colSpan="5">
                                    {props.t("delivery_form.title") ||
                                      "Delivery"}{" "}
                                    {index + 1}
                                  </Table.HeaderCell>
                                  <Table.HeaderCell textAlign="right">
                                    <Button
                                      hidden={index === 0 ? true : false}
                                      size="mini"
                                      basic
                                      color="red"
                                      onClick={() => arrayHelpers.remove(index)}
                                      icon
                                    >
                                      <Icon name="trash" />{" "}
                                      {props.t("delivery_form.title") ||
                                        "Delivery"}
                                    </Button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                {Number(
                                  localStorage.getItem("customerNumber")
                                ) == 549 ? (
                                  <>
                                    {Number(
                                      localStorage.getItem("customerNumber")
                                    ) != 1122 ? (
                                      <>
                                        <Table.Row>
                                          {Number(
                                            localStorage.getItem(
                                              "customerNumber"
                                            )
                                          ) != 1122 ? (
                                            <Table.Cell>
                                              <FormUi.Field
                                                width={3}
                                                className="m-0 mb-2"
                                              >
                                                <label
                                                  className="labelName"
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {props.t(
                                                    "delivery_form.billing_party.title"
                                                  ) || "Billing Party"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <Fieldmik
                                                disabled={
                                                  props?.mode == "view"
                                                    ? true
                                                    : false
                                                }
                                                className="opacity-1"
                                                name={`deliveries[${index}].billing_party_id`}
                                                defaultValue={
                                                  values.deliveries[index]
                                                    .billing_party_id
                                                }
                                                placeholder={
                                                  props.t(
                                                    "delivery_form.billing_party.placeholder"
                                                  ) || "Billing Party"
                                                }
                                                component={
                                                  MyBillingPartyComponent
                                                }
                                                getBillingPartySelected={
                                                  getBillingPartySelected
                                                }
                                                onChange={(name, data) => {
                                                  setFieldValue(
                                                    `deliveries[${index}].billing_party_id`,
                                                    +data.value
                                                  );
                                                  checkBillingParty(name, data, setFieldValue, `deliveries[${index}].customer_type_id`, `deliveries[${index}].customer_type_name`);
                                                }}
                                              />
                                              {touched.billing_party_id &&
                                                errors.billing_party_id ? (
                                                <div className="w3-small w3-text-red">
                                                  {props.t(
                                                    `proposed_vehicle_type.error_msg.${errors.billing_party_id}`
                                                  ) || errors.billing_party_id}
                                                </div>
                                              ) : null}
                                            </Table.Cell>
                                          ) : null}
                                          {Number(
                                            localStorage.getItem(
                                              "customerNumber"
                                            )
                                          ) != 1122 ? (
                                            <Table.Cell>
                                              <FormUi.Field
                                                width={3}
                                                className="m-0 mb-2"
                                              >
                                                <label
                                                  className="labelName"
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {props.t(
                                                    "delivery_form.billing_party_branch.title"
                                                  ) ||
                                                    "Billing Party Branch"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <Dropdown
                                                disabled={
                                                  props?.mode == "view"
                                                    ? true
                                                    : false
                                                }
                                                name={`deliveries[${index}].billing_party_branch_id`}
                                                placeholder={
                                                  values.deliveries[index]
                                                    .billing_party_branch_name
                                                    ? values.deliveries[index]
                                                      .billing_party_branch_name
                                                    : props.t(
                                                      "delivery_form.billing_party_branch.placeholder"
                                                    ) ||
                                                    "Billing Party Branch"
                                                }
                                                clearable
                                                style={{ width: "100%" }}
                                                selection
                                                search
                                                onChange={(name, data) => {
                                                  data.options.map(
                                                    (item, o) => {
                                                      if (
                                                        item.raw
                                                          .billingPartyBranchId ==
                                                        data.value
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].billing_party_branch_name`,
                                                          item.raw
                                                            .billingPartyBranchName
                                                        );
                                                      }
                                                    }
                                                  );
                                                  setFieldValue(
                                                    `deliveries[${index}].billing_party_branch_id`,
                                                    +data.value
                                                  );
                                                }}
                                                options={billingpartybranch}
                                              />
                                            </Table.Cell>
                                          ) : null}
                                        </Table.Row>
                                      </>
                                    ) : null}
                                  </>
                                ) : null}
                                <Table.Row>
                                  <>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field
                                        width={3}
                                        className="m-0 mb-2"
                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t("booking_branch.title") ||
                                            "Booking Branch"}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <Dropdown
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        className="opacity-1"
                                        clearable
                                        style={{
                                          width: "100%",
                                          fontWeight: "normal",
                                          opacity: "1",
                                        }}
                                        search
                                        loading={isloading}
                                        selection
                                        name={`deliveries[${index}].booking_branch_id`}
                                        placeholder={
                                          values.deliveries?.[index]
                                            ?.booking_branch_name
                                            ? values.deliveries[index]
                                              .booking_branch_name
                                            : props.t(
                                              "booking_branch.placeholder"
                                            ) || "Booking Branch"
                                        }
                                        onChange={(name, data) => {
                                          data.options.map((item, o) => {
                                            if (
                                              item.raw.branchId == data.value
                                            ) {
                                              setFieldValue(
                                                `deliveries[${index}].booking_branch_name`,
                                                item.raw.branchName
                                              );
                                            }
                                          });
                                          setFieldValue(
                                            `deliveries[${index}].booking_branch_id`,
                                            data.value
                                          );
                                          FEATURES.lr_series_activated && handleLRSeriesNo(data.value, index,setFieldValue)
                                        }}
                                        options={userbranchs}
                                      />
                                      {touched.service_type_id &&
                                        errors.service_type_id ? (
                                        <div className="w3-small w3-text-red">
                                          {props.t(
                                            `booking_branch.error_msg.${errors.booking_branch}`
                                          ) || errors.booking_branch}
                                        </div>
                                      ) : null}
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field
                                        width={3}
                                        className="m-0 mb-2"
                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t("billing_branch.title") ||
                                            "Billing Branch"}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <Dropdown
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        clearable
                                        style={{
                                          width: "100%",
                                          fontWeight: "normal",
                                          opacity: "1",
                                        }}
                                        search
                                        loading={isloading}
                                        selection
                                        name={`deliveries[${index}].billing_branch_id`}
                                        placeholder={
                                          values?.deliveries?.[index]
                                            ?.billing_branch_name
                                            ? values.deliveries[index]
                                              .billing_branch_name
                                            : props.t(
                                              "billing_branch.placeholder"
                                            ) || "Billing Branch"
                                        }
                                        onChange={(name, data) => {
                                          data.options.map((item, o) => {
                                            if (
                                              item.raw.branchId == data.value
                                            ) {
                                              setFieldValue(
                                                `deliveries[${index}].billing_branch_name`,
                                                item.raw.branchName
                                              );
                                            }
                                          });
                                          setFieldValue(
                                            `deliveries[${index}].billing_branch_id`,
                                            data.value
                                          );
                                        }}
                                        options={userbranchs}
                                      />
                                      {touched.service_type_id &&
                                        errors.service_type_id ? (
                                        <div className="w3-small w3-text-red">
                                          {props.t(
                                            `billing_branch.error_msg.${errors.billing_branch}`
                                          ) || errors.billing_branch}
                                        </div>
                                      ) : null}
                                    </Table.Cell>
                                    <Table.Cell>
                                      <FormUi.Field
                                        width={3}
                                        className="m-0 mb-2"
                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {props.t(
                                            "delivery_form.customer_type.title"
                                          ) || "Customer Type"}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <Dropdown
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        clearable
                                        style={{
                                          width: "100%",
                                          fontWeight: "normal",
                                          opacity: "1",
                                        }}
                                        search
                                        selection
                                        name={`deliveries[${index}].customer_type_name`}
                                        placeholder={
                                          values?.deliveries?.[index]
                                            ?.customer_type_name ?
                                            values.deliveries[index]
                                              .customer_type_name :
                                            props.t(
                                              "delivery_form.customer_type.placeholder"
                                            ) || "Customer Type"
                                        }
                                        value={
                                          values.deliveries[index]
                                            .customer_type_id
                                        }
                                        onChange={(name, data) => {
                                          if (data?.value) {
                                            setFieldValue(
                                              `deliveries[${index}].customer_type_id`,
                                              data.value
                                            )
                                          } else {
                                            setFieldValue(
                                              `deliveries[${index}].customer_type_name`,
                                              null
                                            )
                                          }

                                        }
                                        }
                                        options={customertype}
                                      />
                                      {touched.customer_type_id &&
                                        errors.customer_type_id ? (
                                        <div className="w3-small w3-text-red">
                                          {props.t(
                                            `proposed_vehicle_type.error_msg.${errors.customer_type_id}`
                                          ) || errors.customer_type_id}
                                        </div>
                                      ) : null}
                                    </Table.Cell>
                                    

                                    <Table.Cell>
                                      <FormUi.Field
                                        
                                        className="m-0 mb-2"
                                      >
                                        <label
                                          className="labelName"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {FEATURES.brokerInsteadOfSalesPerson ? 
                                          (props.t(
                                            "delivery_form.broker.title"
                                          ) || "Broker") :
                                          (props.t(
                                            "delivery_form.sales_person.title"
                                          ) || "Sales Person")}{" "}
                                        </label>
                                      </FormUi.Field>
                                      <Fieldmik
                                              placeholder= {FEATURES.brokerInsteadOfSalesPerson ? (props.t("broker.placeholder") || "Broker") : (props.t("sales_person.placeholder") || "Select Sales Person")}
                                              component={MyUser}
                                              name={`deliveries[${index}].sales_person_id`}
                                              roleValidation={true}
                                              roleName={FEATURES.brokerInsteadOfSalesPerson ? "broker" : "sales"}
                                              userNumber='sales_person_number'
                                              userEmail='sales_person_email'
                                              value={values.deliveries[index].sales_person_id}
                                            />
                                            {values.deliveries[index].sales_person_id && 
                                              <div className="mt-1">
                                              <div>
                                                <span className="address-label">{"Contact Number"}</span>
                                                <span className="address-inputfields"> : {values.sales_person_number}
                                                </span>
                                              </div>
                                              <div>
                                                <span className="address-label">{"Email Id"}</span>
                                                <span className="address-inputfields"> : {values.sales_person_email}
                                                </span>
                                              </div>
                                            </div>
                                              }
                                      {touched.sales_person_id &&
                                        errors.sales_person_id ? (
                                        <div className="w3-small w3-text-red">
                                          {errors.sales_person_id}
                                        </div>
                                      ) : null}
                                    </Table.Cell>
                                  </>
                                </Table.Row>

                                {localStorage.getItem("customerNumber") ==
                                  1183 && props.movement_type == "primary" ? (
                                  <>
                                    <Table.Row>
                                      <Table.Cell>
                                        <FormUi.Field
                                          width={3}
                                          className="m-0 mb-2"
                                        >
                                          <label
                                            className="labelName"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.billing_party.title"
                                            ) || "Billing Party"}{" "}
                                            <MandatoryMark />
                                          </label>
                                        </FormUi.Field>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          name={`deliveries[${index}].billing_party_id`}
                                          defaultValue={
                                            values.deliveries[index]
                                              .billing_party_id
                                          }
                                          placeholder={
                                            props.t(
                                              "delivery_form.billing_party.placeholder"
                                            ) || "Billing Party"
                                          }
                                          component={BillingPartyDropdown}
                                          orderModal={true}
                                          getBillingPartySelected={
                                            getBillingPartySelected
                                          }
                                        />
                                        {
                                          <ErrorMessage
                                            name={`deliveries[${index}].billing_party_id`}
                                          >
                                            {(error) => <div>{error}</div>}
                                          </ErrorMessage>
                                        }
                                      </Table.Cell>

                                      <Table.Cell>
                                        <FormUi.Field
                                          width={3}
                                          className="m-0 mb-2"
                                        >
                                          <label
                                            className="labelName"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.billing_party_branch.title"
                                            ) || "Billing Party Branch"}{" "}
                                            <MandatoryMark />
                                          </label>
                                        </FormUi.Field>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          name={`deliveries[${index}].billing_party_branch_id`}
                                          placeholder={
                                            values.deliveries[index]
                                              .billing_party_branch_name
                                              ? values.deliveries[index]
                                                .billing_party_branch_name
                                              : props.t(
                                                "delivery_form.billing_party_branch.placeholder"
                                              ) || "Billing Party Branch"
                                          }
                                          component={BillingPartyBranchDropdown}
                                          setBillingBranchName={(
                                            branchName,
                                            branchId
                                          ) => {
                                            setFieldValue(
                                              `deliveries[${index}].billing_party_branch_name`,
                                              branchName
                                            );
                                            getConsigneeConsignorArray(
                                              values.deliveries[index]
                                                .billing_party_id,
                                              branchId
                                            );
                                          }}
                                          billingPartyBranchArray={
                                            billingpartybranch
                                          }
                                        />
                                        {
                                          <ErrorMessage
                                            name={`deliveries[${index}].billing_party_branch_id`}
                                          >
                                            {(error) => <div>{error}</div>}
                                          </ErrorMessage>
                                        }
                                      </Table.Cell>

                                      <Table.Cell>
                                        <FormUi.Field width={3}>
                                          <label
                                            className="m-0 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.deliver_to.title"
                                            ) || "Deliver To"}{" "}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                          width={3}
                                          error={
                                            touched.deliver_to &&
                                              errors.deliver_to
                                              ? true
                                              : false
                                          }
                                        >
                                          <Dropdown
                                            disabled={
                                              props?.mode == "view"
                                                ? true
                                                : false
                                            }
                                            name={`deliveries[${index}].deliver_to`}
                                            clearable
                                            style={{
                                              width: "100%",
                                              fontWeight: "normal",
                                            }}
                                            selection
                                            placeholder={
                                              props.t(
                                                "delivery_form.deliver_to.placeholder"
                                              ) || "Deliver To"
                                            }
                                            onChange={(name, data) => {
                                              if (data.value == "consignee") {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  values.deliveries[index]
                                                    .consignee_address
                                                );
                                              } else if (
                                                data.value == "other"
                                              ) {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  ""
                                                );
                                              }
                                              setFieldValue(
                                                `deliveries[${index}].deliver_to`,
                                                data.value
                                              );
                                            }}
                                            options={[
                                              {
                                                key: "1",
                                                text: "Consignee",
                                                value: "consignee",
                                              },
                                              {
                                                key: "2",
                                                text: "Branch",
                                                value: "branch",
                                              },
                                              {
                                                key: "3",
                                                text: "Other",
                                                value: "other",
                                              },
                                            ]}
                                            value={
                                              values.deliveries[index]
                                                .deliver_to
                                                ? values.deliveries[index]
                                                  .deliver_to
                                                : "consignee"
                                            }
                                          />
                                          {touched.deliver_to &&
                                            errors.deliver_to ? (
                                            <div className="w3-small w3-text-red">
                                              {props.t(
                                                `shipment_form.deliver_to.error_msg.${errors.deliver_to}`
                                              ) || errors.deliver_to}
                                            </div>
                                          ) : null}
                                        </FormUi.Field>
                                      </Table.Cell>

                                      {values.deliveries[index].deliver_to ==
                                        "branch" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.deliver_to_branch.title"
                                                ) || "Deliver To"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <Dropdown
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              name={`deliveries[${index}].deliver_to_address`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to_branch.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  data.value
                                                );
                                              }}
                                              options={branchs}
                                              value={
                                                values.deliveries[index]
                                                  .deliver_to_address
                                              }
                                            />
                                          </Table.Cell>
                                        </>
                                      ) : null}
                                      {values.deliveries[index].deliver_to ==
                                        "other" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.reason.title"
                                                ) || "Reason"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              error={
                                                touched.other && errors.other
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Fieldmik
                                                disabled={
                                                  props?.mode == "view"
                                                    ? true
                                                    : false
                                                }
                                                component="textarea"
                                                style={{
                                                  paddingTop: "5.5px",
                                                  whiteSpace: "nowrap",
                                                }}
                                                type="number"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                              />
                                            </FormUi.Field>
                                          </Table.Cell>
                                        </>
                                      ) : (
                                        <>
                                          {values.deliveries[index]
                                            .deliver_to == "consignee" ? (
                                            <>
                                              <Table.Cell>
                                                <label className="labelName">
                                                  {props.movement_type ==
                                                    "import" ||
                                                    props.movement_type ==
                                                    "export" ? (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.delivery_location_address.title"
                                                      ) ||
                                                        "Delivery Location Address"}{" "}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.consignee_address.title"
                                                      ) ||
                                                        "Consignee Address"}{" "}
                                                    </>
                                                  )}
                                                </label>
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  readOnly
                                                  component="textarea"
                                                  rows="2"
                                                  name={`deliveries[${index}].deliver_to_address`}
                                                  value={
                                                    values.deliveries[index]
                                                      .deliver_to_address
                                                  }
                                                />
                                              </Table.Cell>
                                            </>
                                          ) : null}
                                        </>
                                      )}
                                    </Table.Row>
                                  </>
                                ) : (
                                  ""
                                )}

                                <Table.Row key={index} colSpan="6">
                                  {props.movement_type != "primary" &&
                                    props.movement_type == "export" ? (
                                    <Table.Cell>
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.yard.title"
                                          ) || "Yard"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}
                                        error={
                                          touched.container_type &&
                                            errors.container_type
                                            ? true
                                            : false
                                        }
                                      >
                                        <Dropdown
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          name={`deliveries[${index}].yard_id`}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.yard.title"
                                            ) || "Yard"
                                          }
                                          defaultValue={
                                            values.deliveries[index].yard_id
                                          }
                                          onChange={(name, data) =>
                                            setFieldValue(
                                              `deliveries[${index}].yard_id`,
                                              data.value
                                            )
                                          }
                                          options={yard}
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                  ) : null}
                                  <Table.Cell>
                                    <label className="labelName">
                                      {props.movement_type == "import" ? (
                                        <>
                                          {props.t(
                                            "delivery_form.port_terminal.title"
                                          ) || "Port Terminal"}{" "}
                                          <MandatoryMark />
                                        </>
                                      ) : (
                                        <>
                                          {props.movement_type == "export" ? (
                                            <>
                                              {props.t(
                                                "delivery_form.export_pickup_location.title"
                                              ) || "Stuffing location"}{" "}
                                              <MandatoryMark />
                                            </>
                                          ) : (
                                            <>
                                              {props.t(
                                                "delivery_form.consignor.title"
                                              ) || "Consignor"}{" "}
                                              <MandatoryMark />
                                            </>
                                          )}
                                        </>
                                      )}
                                    </label>
                                    <br></br>
                                    <div className="ui action input">
                                      <Fieldmik
                                        name={`deliveries[${index}].consignor_code`}
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        style={{
                                          opacity: "1",
                                        }}
                                        placeholder={
                                          props.movement_type == "import"
                                            ? values.deliveries[index]
                                              .consignor_name
                                              ? values.deliveries[index]
                                                .consignor_name
                                              : props.t(
                                                "delivery_form.port_terminal.placeholder"
                                              ) || "Delivery Location"
                                            : values.deliveries[index]
                                              .consignor_name
                                              ? values.deliveries[index]
                                                .consignor_name
                                              : props.movement_type == "export"
                                                ? props.t(
                                                  "delivery_form.pickup_location.placeholder"
                                                )
                                                : props.t(
                                                  "delivery_form.consignor.placeholder"
                                                )
                                        }
                                        consignorIDName={`deliveries[${index}].consignor_id`}
                                        component={MyConsignor}
                                        consignorArray={consignorArray}
                                        gst={`deliveries[${index}].consignor_gstNumber`}
                                        address={`deliveries[${index}].consignor_address`}
                                        cname={`deliveries[${index}].consignor_name`}
                                      />
                                      <ModalCreateConsignor
                                        reFetchConsignor={getIntialCall}
                                      />
                                    </div>

                                    {
                                      <ErrorMessages
                                        name={`deliveries[${index}].consignor_code`}
                                        trans={"delivery_form.consignor"}
                                      />
                                    }

                                    <br />
                                    <br />
                                    <label className="labelName">
                                      Pickup Area
                                    </label>
                                    <Fieldmik
                                      name={`deliveries.[${index}].pickup_area`}
                                      placeholder={
                                        values?.deliveries?.[
                                          index
                                        ]?.pickup_area
                                          ? values.deliveries[
                                            index
                                          ].pickup_area
                                          : null
                                      }
                                      dontLoadInit={false}
                                      setData={
                                        values?.deliveries?.[
                                          index
                                        ]?.pickup_area
                                      }
                                      component={MyTextArea}
                                      consignorIDName={`deliveries[${index}].pickup_area`}
                                      value={
                                        values.deliveries[
                                          index
                                        ]?.pickup_area
                                      }
                                    />
                                  </Table.Cell>
                                  <Table.Cell>
                                    <label className="labelName">
                                      {props.movement_type == "import" ? (
                                        <>
                                          {props.t(
                                            "delivery_form.delivery_location.title"
                                          ) || "Delivery Location"}{" "}
                                          <MandatoryMark />
                                        </>
                                      ) : (
                                        <>
                                          {props.movement_type == "export" ? (
                                            <>
                                              {props.t(
                                                "delivery_form.port_terminal.title"
                                              ) || "Port Terminal"}{" "}
                                              <MandatoryMark />
                                            </>
                                          ) : (
                                            <>
                                              {props.t(
                                                "delivery_form.consignee.title"
                                              ) || "Consignee"}{" "}
                                              <MandatoryMark />
                                            </>
                                          )}
                                        </>
                                      )}
                                    </label>
                                    <br></br>
                                    <div className="ui action input">
                                      <Fieldmik
                                        name={`deliveries[${index}].consignee_code`}
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        style={{
                                          opacity: "1",
                                        }}
                                        placeholder={
                                          props.movement_type == "import"
                                            ? values.deliveries[index]
                                              .consignee_name
                                              ? values.deliveries[index]
                                                .consignee_name
                                              : props.t(
                                                "delivery_form.delivery_location.placeholder"
                                              ) || "Delivery Location"
                                            : values.deliveries[index]
                                              .consignee_name
                                              ? values.deliveries[index]
                                                .consignee_name
                                              : props.movement_type == "export"
                                                ? props.t(
                                                  "delivery_form.port_terminal.placeholder"
                                                )
                                                : props.t(
                                                  "delivery_form.consignee.placeholder"
                                                )
                                        }
                                        component={MyConsigneeComponent}
                                        consigneeIDName={`deliveries[${index}].consignee_id`}
                                        consigneeArray={consigneeArray}
                                        gst={`deliveries[${index}].consignee_gstNumber`}
                                        address={`deliveries[${index}].consignee_address`}
                                        deliverTo={`deliveries[${index}].deliver_to_address`}
                                        cename={`deliveries[${index}].consignee_name`}
                                      />

                                      <ModalCreateConsignee
                                        reFetchConsignee={() => getIntialCall()}
                                      />
                                    </div>
                                    {
                                      <ErrorMessages
                                        name={`deliveries[${index}].consignee_code`}
                                        trans={"delivery_form.consignee"}
                                      />
                                    }

                                    <br />
                                    <br />
                                    <label className="labelName">
                                      Drop Area
                                    </label>
                                    <Fieldmik
                                      name={`deliveries.[${index}].drop_area`}
                                      placeholder={
                                        values?.deliveries?.[
                                          index
                                        ]?.drop_area
                                          ? values.deliveries[
                                            index
                                          ].drop_area
                                          : null
                                      }
                                      dontLoadInit={false}
                                      setData={
                                        values?.deliveries?.[
                                          index
                                        ]?.drop_area
                                      }
                                      component={MyTextArea}
                                      consignorIDName={`deliveries[${index}].drop_area`}
                                      value={
                                        values.deliveries[
                                          index
                                        ]?.drop_area
                                      }
                                    />
                                  </Table.Cell>
                                  {props.movement_type != "primary" &&
                                    props.movement_type == "import" ? (
                                    <Table.Cell>
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.yard.title"
                                          ) || "Yard"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}
                                        error={
                                          touched.container_type &&
                                            errors.container_type
                                            ? true
                                            : false
                                        }
                                      >
                                        <Dropdown
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          name={`deliveries[${index}].yard_id`}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.yard.title"
                                            ) || "Yard"
                                          }
                                          defaultValue={
                                            values.deliveries[index].yard_id
                                          }
                                          onChange={(name, data) =>
                                            setFieldValue(
                                              `deliveries[${index}].yard_id`,
                                              data.value
                                            )
                                          }
                                          options={yard}
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                  ) : null}
                                  {Number(
                                    localStorage.getItem("customerNumber")
                                  ) == 549 ? (
                                    <>
                                      <Table.Cell>
                                        <FormUi.Field width={3}>
                                          <label
                                            className="m-0 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.deliver_to.title"
                                            ) || "Deliver To"}{" "}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                          width={3}
                                          error={
                                            touched.deliver_to &&
                                              errors.deliver_to
                                              ? true
                                              : false
                                          }
                                        >
                                          <Dropdown
                                            disabled={
                                              props?.mode == "view"
                                                ? true
                                                : false
                                            }
                                            name={`deliveries[${index}].deliver_to`}
                                            clearable
                                            style={{
                                              width: "100%",
                                              fontWeight: "normal",
                                            }}
                                            selection
                                            placeholder={
                                              props.t(
                                                "delivery_form.deliver_to.placeholder"
                                              ) || "Deliver To"
                                            }
                                            onChange={(name, data) => {
                                              if (data.value == "consignee") {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  values.deliveries[index]
                                                    .consignee_address
                                                );
                                              } else if (
                                                data.value == "other"
                                              ) {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  ""
                                                );
                                              }
                                              setFieldValue(
                                                `deliveries[${index}].deliver_to`,
                                                data.value
                                              );
                                            }}
                                            options={[
                                              {
                                                key: "1",
                                                text: "Consignee",
                                                value: "consignee",
                                              },
                                              {
                                                key: "2",
                                                text: "Branch",
                                                value: "branch",
                                              },
                                              {
                                                key: "3",
                                                text: "Other",
                                                value: "other",
                                              },
                                            ]}
                                            value={
                                              values.deliveries[index]
                                                .deliver_to
                                                ? values.deliveries[index]
                                                  .deliver_to
                                                : "consignee"
                                            }
                                          />
                                          {touched.deliver_to &&
                                            errors.deliver_to ? (
                                            <div className="w3-small w3-text-red">
                                              {props.t(
                                                `shipment_form.deliver_to.error_msg.${errors.deliver_to}`
                                              ) || errors.deliver_to}
                                            </div>
                                          ) : null}
                                        </FormUi.Field>
                                      </Table.Cell>
                                      {values.deliveries[index].deliver_to ==
                                        "branch" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.deliver_to_branch.title"
                                                ) || "Deliver To"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <Dropdown
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              name={`deliveries[${index}].deliver_to_address`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to_branch.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  data.value
                                                );
                                              }}
                                              options={branchs}
                                              value={
                                                values.deliveries[index]
                                                  .deliver_to_address
                                              }
                                            />
                                          </Table.Cell>
                                        </>
                                      ) : null}
                                      {values.deliveries[index].deliver_to ==
                                        "other" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.reason.title"
                                                ) || "Reason"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              error={
                                                touched.other && errors.other
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Fieldmik
                                                disabled={
                                                  props?.mode == "view"
                                                    ? true
                                                    : false
                                                }
                                                component="textarea"
                                                style={{
                                                  paddingTop: "5.5px",
                                                  whiteSpace: "nowrap",
                                                }}
                                                type="number"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                              />
                                            </FormUi.Field>
                                          </Table.Cell>
                                        </>
                                      ) : (
                                        <>
                                          {values.deliveries[index]
                                            .deliver_to == "consignee" ? (
                                            <>
                                              <Table.Cell>
                                                <label className="labelName">
                                                  {props.movement_type ==
                                                    "import" ||
                                                    props.movement_type ==
                                                    "export" ? (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.delivery_location_address.title"
                                                      ) ||
                                                        "Delivery Location Address"}{" "}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.consignee_address.title"
                                                      ) ||
                                                        "Consignee Address"}{" "}
                                                    </>
                                                  )}
                                                </label>
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  readOnly
                                                  component="textarea"
                                                  rows="2"
                                                  name={`deliveries[${index}].deliver_to_address`}
                                                  value={
                                                    values.deliveries[index]
                                                      .deliver_to_address
                                                  }
                                                />
                                              </Table.Cell>
                                            </>
                                          ) : null}
                                        </>
                                      )}
                                    </>
                                  ) : null}
                                </Table.Row>
                                <Table.Row>
                                  <Table.Cell>
                                    <div>
                                      <label className="labelName">
                                        {props.movement_type == "import" ||
                                          props.movement_type == "export" ? (
                                          <>
                                            {props.t(
                                              "delivery_form.port_terminal_address.title"
                                            ) || "Port Terminal Address"}{" "}
                                            <span> : </span>
                                          </>
                                        ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignor_address.title"
                                            ) || "Consignor Address"}{" "}
                                            <span> : </span>
                                          </>
                                        )}
                                      </label>
                                      <label className="labelName address-label-shipment">
                                        &nbsp;
                                        {values.deliveries[index]
                                          .consignor_address
                                          ? values.deliveries[index]
                                            .consignor_address
                                          : "NA"}
                                      </label>
                                      {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignor_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_address
                                        }
                                      /> */}
                                    </div>

                                    <div>
                                      <label className="labelName">
                                        {props.movement_type == "import" ||
                                          props.movement_type == "export" ? (
                                          <>
                                            {props.t(
                                              "delivery_form.consignor_gst.title"
                                            ) || "Port Terminal Address"}{" "}
                                            <span> : </span>
                                          </>
                                        ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignor_gst.title"
                                            ) || "Consignor Address"}{" "}
                                            <span> : </span>
                                          </>
                                        )}
                                      </label>
                                      <label className="labelName address-label-shipment">
                                        &nbsp;
                                        {values.deliveries[index]
                                          .consignor_gstNumber
                                          ? values.deliveries[index]
                                            .consignor_gstNumber
                                          : "NA"}
                                      </label>
                                      {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignor_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignor_gstNumber
                                        }
                                      /> */}
                                    </div>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <div>
                                      <label className="labelName">
                                        {props.movement_type == "import" ||
                                          props.movement_type == "export" ? (
                                          <>
                                            {props.t(
                                              "delivery_form.delivery_location_address.title"
                                            ) ||
                                              "Delivery Location Address"}{" "}
                                            <span> : </span>
                                          </>
                                        ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignee_address.title"
                                            ) || "Consignee Address"}{" "}
                                            <span> : </span>
                                          </>
                                        )}
                                      </label>
                                      <label className="labelName address-label-shipment">
                                        &nbsp;
                                        {values.deliveries[index]
                                          .consignee_address
                                          ? values.deliveries[index]
                                            .consignee_address
                                          : "NA"}
                                      </label>
                                      {/* <Fieldmik
                                        readOnly
                                        component="textarea"
                                        rows="2"
                                        name={`deliveries[${index}].consignee_address`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_address
                                        }
                                      /> */}
                                    </div>
                                    <div>
                                      <label className="labelName">
                                        {props.movement_type == "import" ||
                                          props.movement_type == "export" ? (
                                          <>
                                            {props.t(
                                              "delivery_form.consignee_gst.title"
                                            ) ||
                                              "Delivery Location Address"}{" "}
                                            <span> : </span>
                                          </>
                                        ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignee_gst.title"
                                            ) || "Consignee Address"}{" "}
                                            <span> : </span>
                                          </>
                                        )}
                                      </label>
                                      <label className="labelName address-label-shipment">
                                        &nbsp;
                                        {values.deliveries[index]
                                          .consignee_gstNumber
                                          ? values.deliveries[index]
                                            .consignee_gstNumber
                                          : "NA"}
                                      </label>
                                      {/* <Fieldmik
                                        readOnly
                                        component={MyNormalInput}
                                        rows="2"
                                        name={`deliveries[${index}].consignee_gstNumber`}
                                        defaultValue={
                                          values.deliveries[index]
                                            .consignee_gstNumber
                                        }
                                      /> */}
                                    </div>
                                  </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                  <Table.Cell>
                                    <FormUi.Field
                                      width={3}
                                      className="m-0 mb-2"
                                    >
                                      <label
                                        className="labelName"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        {props.t(
                                          "delivery_form.container_pickup_date.title"
                                        ) || "Container Pickup Date"}{" "}
                                        <MandatoryMark />
                                      </label>
                                    </FormUi.Field>
                                    <DateData
                                      disabled={
                                        props?.mode == "view" ? true : false
                                      }
                                      style={{
                                        opacity: "1",
                                      }}
                                      name={`deliveries[${index}].container_pickup_date_t`}
                                      tname={`deliveries[${index}].container_pickup_date`}
                                      autoComplete="off"
                                      showTimeSelect
                                      timeFormat="HH:mm"
                                      popperClassName="dateTime"
                                      dateFormat="dd/MM/yyyy HH:mm"
                                      timeIntervals={5}
                                      customInput={
                                        <Input
                                          icon="time"
                                          iconPosition="left"
                                        />
                                      }
                                    />
                                  </Table.Cell>
                                  <Table.Cell
                                    colSpan={
                                      values.load_type_id == "2" ||
                                        values.load_type_id == "1"
                                        ? "0"
                                        : "6"
                                    }
                                  >
                                    <FormUi.Field
                                      width={3}
                                      className="m-0 mb-2"
                                    >
                                      <label
                                        className="labelName"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        {props.t(
                                          "delivery_form.container_return_date.title"
                                        ) || "Container Return Date"}{" "}
                                        <MandatoryMark />
                                      </label>
                                    </FormUi.Field>
                                    <DateData
                                      disabled={
                                        props?.mode == "view" ? true : false
                                      }
                                      style={{
                                        opacity: "1",
                                      }}
                                      name={`deliveries[${index}].delivery_date_t`}
                                      tname={`deliveries[${index}].delivery_date`}
                                      autoComplete="off"
                                      showTimeSelect
                                      timeFormat="HH:mm"
                                      popperClassName="dateTime"
                                      dateFormat="dd/MM/yyyy HH:mm"
                                      timeIntervals={5}
                                      customInput={
                                        <Input
                                          icon="time"
                                          iconPosition="left"
                                        />
                                      }
                                    />
                                  </Table.Cell>
                                  {values.load_type_id == "2" ||
                                    values.load_type_id == "1" ? (
                                    <>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          component={MyNumInput}
                                          icon="thermometer quarter"
                                          iconPosition="left"
                                          style={{ paddingTop: "5.5px" }}
                                          label={
                                            props.t(
                                              "delivery_form.temperature_min.title"
                                            ) || "Temperature Minimum"
                                          }
                                          type="number"
                                          value={
                                            values.deliveries[index].min_temp
                                          }
                                          name={`deliveries[${index}].min_temp`}
                                          error={
                                            getIn(
                                              errors,
                                              `deliveries[${index}].min_temp`
                                            ) &&
                                              getIn(
                                                touched,
                                                `deliveries[${index}].min_temp`
                                              )
                                              ? true
                                              : false
                                          }
                                        />
                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].min_temp`}
                                            trans={
                                              "delivery_form.temperature_min"
                                            }
                                          />
                                        }
                                      </Table.Cell>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          component={MyNumInput}
                                          icon="thermometer quarter"
                                          iconPosition="left"
                                          style={{ paddingTop: "5.5px" }}
                                          label={
                                            props.t(
                                              "delivery_form.temperature_max.title"
                                            ) || "Temperature Maximum"
                                          }
                                          type="number"
                                          value={
                                            values.deliveries[index].max_temp
                                          }
                                          name={`deliveries[${index}].max_temp`}
                                          error={
                                            getIn(
                                              errors,
                                              `deliveries[${index}].max_temp`
                                            ) &&
                                              getIn(
                                                touched,
                                                `deliveries[${index}].max_temp`
                                              )
                                              ? true
                                              : false
                                          }
                                        />
                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].max_temp`}
                                            trans={
                                              "delivery_form.temperature_max"
                                            }
                                          />
                                        }
                                      </Table.Cell>
                                    </>
                                  ) : null}
                                </Table.Row>
                                {Number(
                                  localStorage.getItem("customerNumber")
                                ) != 1122 ? (
                                  <>
                                    <Table.Row>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true :false
                                          }
                                          readOnly={props?.deliveryDataFetch?.order?.vendor_name && FEATURES.lr_series_fixed(props?.deliveryDataFetch?.order?.vendor_name) && values.deliveries[index].is_lr_generated_by_lr_series}
                                          component={MyInput}
                                          style={{
                                            paddingTop: "5.5px",
                                            whiteSpace: "nowrap",
                                            opacity: "1",
                                          }}
                                          label={
                                            values.ownership_type_id == 2
                                              ? props.t(
                                                "delivery_form.transporter_lr_no.title"
                                              ) || "LR No"
                                              : props.t(
                                                "delivery_form.transporter_lr_no.title"
                                              ) || "LR No"
                                          }
                                          value={values.deliveries[index].lr_no}
                                          name={`deliveries[${index}].lr_no`}
                                        />
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormUi.Field
                                          width={3}
                                          className="m-0 mb-2"
                                        >
                                          <label
                                            className="labelName"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {values.ownership_type_id == 2
                                              ? props.t(
                                                "delivery_form.transporter_lr_date.title"
                                              ) || "Vendor LR date"
                                              : props.t(
                                                "delivery_form.transporter_lr_date.title"
                                              ) || "LR date"}
                                          </label>
                                        </FormUi.Field>
                                        <DateData
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          style={{
                                            opacity: "1",
                                          }}
                                          name={`deliveries[${index}].lr_date_t`}
                                          tname={`deliveries[${index}].lr_date`}
                                          autoComplete="off"
                                          timeFormat="HH:mm"
                                          popperClassName="dateTime"
                                          dateFormat="dd/MM/yyyy HH:mm"
                                          timeIntervals={5}
                                          customInput={
                                            <Input
                                              icon="time"
                                              iconPosition="left"
                                            />
                                          }
                                        />
                                      </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          component={MyNumInput}
                                          style={{
                                            paddingTop: "5.5px",
                                            whiteSpace: "nowrap",
                                            opacity: "1",
                                          }}
                                          label={
                                            props.t(
                                              "delivery_form.actual_weight.title"
                                            ) || "Container Number"
                                          }
                                          type="number"
                                          value={
                                            values.deliveries[index]
                                              .actual_weight
                                          }
                                          name={`deliveries[${index}].actual_weight`}
                                        />
                                      </Table.Cell>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          component={MyNumInput}
                                          style={{
                                            paddingTop: "5.5px",
                                            whiteSpace: "nowrap",
                                            opacity: "1",
                                          }}
                                          label={
                                            props.t(
                                              "delivery_form.gross_weight.title"
                                            ) || "Container Number"
                                          }
                                          type="number"
                                          value={
                                            values.deliveries[index]
                                              .gross_weight
                                          }
                                          name={`deliveries[${index}].gross_weight`}
                                        />
                                      </Table.Cell>
                                      <Table.Cell colSpan="1">
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.charge_weight.title"
                                            ) || "Charged Weight"}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field className="m-0 mb-2">
                                          <Input
                                            disabled={
                                              props?.mode == "view"
                                                ? true
                                                : false
                                            }
                                            style={{
                                              opacity: "1",
                                            }}
                                            type="number"
                                            value={
                                              // values.deliveries[index]
                                              //   .charged_weight
                                              Number(
                                                values.deliveries[index]
                                                  .charged_weight
                                              )
                                            }
                                            name={`deliveries[${index}].charged_weight`}
                                            onChange={(name, data) => {
                                              let multiplyFactor = 0,
                                                actualValue = 0;
                                              let actualFreightValue =
                                                values?.deliveries?.[index]
                                                  ?.actual_freight_rate;
                                              setFieldValue(
                                                `deliveries[${index}].charged_weight`,
                                                Number(data.value) //data.value
                                              );
                                              if (
                                                values?.deliveries?.[index]?.uom
                                              ) {
                                                if (parseInt(data.value) > 0) {
                                                  multiplyFactor = data.value;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                  if (
                                                    values?.deliveries?.[index]
                                                      ?.uom === "kg"
                                                  ) {
                                                    multiplyFactor = data.value;
                                                    actualValue =
                                                      multiplyFactor *
                                                      actualFreightValue;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`,
                                                      actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                  } else if (
                                                    values?.deliveries?.[index]
                                                      ?.uom === "ton"
                                                  ) {
                                                    multiplyFactor =
                                                      data.value / 1000;
                                                    actualValue =
                                                      multiplyFactor *
                                                      actualFreightValue;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`,
                                                      actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                  } else if (
                                                    values?.deliveries?.[index]
                                                      ?.uom === "cft"
                                                  ) {
                                                    let tempVolume = 0;
                                                    let tempProductQty = 0;
                                                    for (
                                                      let indx = 0;
                                                      indx <
                                                      values.deliveries[index]
                                                        .products.length;
                                                      indx++
                                                    ) {
                                                      if (
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx]
                                                          .length &&
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx]
                                                          .breadth &&
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx].height
                                                      ) {
                                                        tempVolume =
                                                          tempVolume +
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .length *
                                                          values
                                                            ?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .breadth *
                                                          values
                                                            ?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .height;
                                                      }
                                                    }
                                                    if (
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.total_quantity
                                                    ) {
                                                      tempProductQty =
                                                        values.deliveries[index]
                                                          .total_quantity *
                                                        data.value *
                                                        tempVolume;
                                                      multiplyFactor =
                                                        values.deliveries[index]
                                                          .total_quantity *
                                                        tempVolume;
                                                      actualValue =
                                                        multiplyFactor *
                                                        actualFreightValue +
                                                        tempProductQty;
                                                      setFieldValue(
                                                        `deliveries[${index}].final_freight_rate`,
                                                        actualValue
                                                      );
                                                      setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                    }
                                                  }
                                                } else if (
                                                  parseInt(data.value) == 0 &&
                                                  values?.deliveries?.[index]
                                                    ?.uom === "ton" &&
                                                  values?.deliveries?.[index]
                                                    ?.uom === "kg"
                                                ) {
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    values.deliveries[index]
                                                      .actual_freight_rate
                                                  );
                                                }
                                              }
                                            }}
                                          />
                                        </FormUi.Field>
                                      </Table.Cell>

                                      <Table.Cell colSpan="1">
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.total_quantity.title"
                                            ) || "Total Ordered Quantity"}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field className="m-0 mb-2">
                                          <Input
                                            disabled={
                                              props?.mode == "view"
                                                ? true
                                                : false
                                            }
                                            style={{
                                              opacity: "1",
                                            }}
                                            type="number"
                                            value={
                                              // values.deliveries[index]
                                              //   .total_quantity
                                              Number(
                                                values.deliveries[index]
                                                  .total_quantity
                                              )
                                            }
                                            name={`deliveries[${index}].total_quantity`}
                                            onChange={(name, data) => {
                                              let multiplyFactor = 0,
                                                actualValue = 0;
                                              let actualFreightValue =
                                                values?.deliveries?.[index]
                                                  ?.actual_freight_rate;
                                              setFieldValue(
                                                `deliveries[${index}].total_quantity`,
                                                Number(data.value) //data.value
                                              );
                                              if (parseInt(data.value) > 0) {
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.uom
                                                ) {
                                                  if (
                                                    values?.deliveries?.[index]
                                                      ?.uom === "percase"
                                                  ) {
                                                    multiplyFactor = data.value;
                                                    actualValue =
                                                      multiplyFactor *
                                                      actualFreightValue;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`,
                                                      actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                  } else if (
                                                    values?.deliveries?.[index]
                                                      ?.uom === "cft"
                                                  ) {
                                                    let tempVolume = 0;
                                                    let tempCharge = 0;
                                                    for (
                                                      let indx = 0;
                                                      indx <
                                                      values.deliveries[index]
                                                        .products.length;
                                                      indx++
                                                    ) {
                                                      if (
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx]
                                                          .length &&
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx]
                                                          .breadth &&
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.products[indx].height
                                                      ) {
                                                        tempVolume =
                                                          tempVolume +
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .length *
                                                          values
                                                            ?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .breadth *
                                                          values
                                                            ?.deliveries?.[
                                                            index
                                                          ]?.products[indx]
                                                            .height;
                                                      }
                                                    }
                                                    if (
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.charged_weight
                                                    ) {
                                                      tempCharge =
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.charged_weight *
                                                        data.value *
                                                        tempVolume;
                                                    }
                                                    multiplyFactor =
                                                      data.value * tempVolume;
                                                    actualValue =
                                                      multiplyFactor *
                                                      actualFreightValue +
                                                      tempCharge;
                                                    setFieldValue(
                                                      `deliveries[${index}].final_freight_rate`,
                                                      actualValue
                                                    );
                                                    setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                  }
                                                }
                                              } else if (
                                                parseInt(data.value) == 0 &&
                                                values?.deliveries?.[index]
                                                  ?.uom === "percase" &&
                                                values?.deliveries?.[index]
                                                  ?.uom === "cft"
                                              ) {
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`,
                                                  values.deliveries[index]
                                                    .actual_freight_rate
                                                );
                                              }
                                            }}
                                          />
                                        </FormUi.Field>
                                      </Table.Cell>
                                    </Table.Row>
                                  </>
                                ) : null}
                                {(props.movement_type == "export" ||
                                  props.movement_type == "import") && (
                                    <>
                                      <Table.Row>
                                        <Table.Cell>
                                          <FormUi.Field className="m-0 mb-2">
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.container_number.title"
                                              ) || "Container Type"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <Fieldmik
                                            disabled={
                                              props?.mode == "view" ? true : false
                                            }
                                            component={MyInput}
                                            style={{
                                              width: "100%",
                                              fontWeight: "normal",
                                              opacity: "1",
                                            }}
                                            selection
                                            placeholder={
                                              props.t(
                                                "delivery_form.container_type.title"
                                              ) || "Container Type"
                                            }
                                            name={`deliveries[${index}].container_no`}
                                          />
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field className="m-0 mb-2">
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.container_type.title"
                                              ) || "Container Type"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.container_type &&
                                                errors.container_type
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                                opacity: "1",
                                              }}
                                              search
                                              name={`deliveries[${index}].container_type`}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.container_type.title"
                                                ) || "Container Type"
                                              }
                                              defaultValue={
                                                values.deliveries[index]
                                                  .container_type
                                              }
                                              onChange={(name, data) =>
                                                setFieldValue(
                                                  `deliveries[${index}].container_type`,
                                                  data.value
                                                )
                                              }
                                              options={[
                                                {
                                                  key: "1",
                                                  text: "20 Feet",
                                                  value: "FT20",
                                                },
                                                {
                                                  key: "2",
                                                  text: "40 Feet",
                                                  value: "FT40",
                                                },
                                              ]}
                                            />
                                            {touched.container_type &&
                                              errors.container_type ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `container_type.error_msg.${errors.container_type}`
                                                ) || errors.container_type}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field className="m-0 mb-2">
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.container_type_id.title"
                                              ) || "Container Type"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.container_type &&
                                                errors.container_type
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                                opacity: "1",
                                              }}
                                              search
                                              name={`deliveries[${index}].container_type_id`}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.container_type_id.title"
                                                ) || "Container Type"
                                              }
                                              defaultValue={
                                                values.deliveries[index]
                                                  .container_type_id
                                              }
                                              onChange={(name, data) =>
                                                setFieldValue(
                                                  `deliveries[${index}].container_type_id`,
                                                  data.value
                                                )
                                              }
                                              options={containerType}
                                            />
                                            {touched.container_type &&
                                              errors.container_type ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `container_type_id.error_msg.${errors.container_type_id}`
                                                ) || errors.container_type_id}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field className="m-0 mb-2">
                                            <label className="labelName">
                                              {props.t(
                                                "delivery_form.container_seal_no.title"
                                              ) || "Container Seal No"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            error={
                                              touched.container_seal_no &&
                                                errors.container_seal_no
                                                ? true
                                                : false
                                            }
                                            style={{
                                              width: "100%!important",
                                            }}
                                          >
                                            <Fieldmik
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              component={MyInput}
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                                opacity: "1",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.container_seal_no.title"
                                                ) || "Container Seal No."
                                              }
                                              name={`deliveries[${index}].container_seal_no`}
                                            />
                                            {touched.container_seal_no &&
                                              errors.container_seal_no ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `container_seal_no.error_msg.${errors.container_seal_no}`
                                                ) || errors.container_seal_no}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </Table.Cell>
                                      </Table.Row>
                                    </>
                                  )}
                                {(props.movement_type == "import" ||
                                  props.movement_type == "export") && (
                                    <>
                                      <Table.Row>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {localStorage.getItem(
                                                "customerNumber"
                                              ) == 1327 ? (
                                                <>
                                                  {props.t(
                                                    "delivery_form.do_no_expiration.title"
                                                  ) ||
                                                    "Demurrage Expiration"}{" "}
                                                </>
                                              ) : (
                                                <>
                                                  {props.t(
                                                    "delivery_form.demurrage_expiration.title"
                                                  ) ||
                                                    "Demurrage Expiration"}{" "}
                                                </>
                                              )}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            disabled={
                                              props?.mode == "view" ? true : false
                                            }
                                            style={{
                                              opacity: "1",
                                            }}
                                            name={`deliveries[${index}].demurrage_expiration_date_t`}
                                            tname={`deliveries[${index}].demurrage_expiration_date`}
                                            autoComplete="off"
                                            // showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.ata_date.title"
                                              ) || "ATA"}{" "}
                                              {/* {props.t(
                                              "delivery_form.delivery_date.title"
                                            ) || "Storage Expiration"}{" "} */}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            disabled={
                                              props?.mode == "view" ? true : false
                                            }
                                            style={{
                                              opacity: "1",
                                            }}
                                            name={`deliveries[${index}].ata_date_t`}
                                            tname={`deliveries[${index}].ata_date`}
                                            autoComplete="off"
                                            // showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                iconPosition="left"
                                              />
                                            }
                                            error={
                                              getIn(
                                                errors,
                                                `deliveries[${index}].ata_date`
                                              ) &&
                                                getIn(
                                                  touched,
                                                  `deliveries[${index}].ata_date`
                                                )
                                                ? true
                                                : false
                                            }
                                          />
                                          {
                                            <ErrorMessages
                                              name={`deliveries[${index}].ata_date`}
                                              trans={"delivery_form.ata_date"}
                                            />
                                          }
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.storage_expiration.title"
                                              ) || "Storage Expiration"}{" "}
                                              {/* <MandatoryMark /> */}
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            disabled={
                                              props?.mode == "view" ? true : false
                                            }
                                            style={{
                                              opacity: "1",
                                            }}
                                            name={`deliveries[${index}].storage_expiration_date_t`}
                                            tname={`deliveries[${index}].storage_expiration_date`}
                                            autoComplete="off"
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                        {props.movement_type == "import" ? (
                                          <>
                                            <Table.Cell>
                                              <FormUi.Field>
                                                <label className="labelName">
                                                  {props.t(
                                                    "delivery_form.import_declaration_no.title"
                                                  ) ||
                                                    "import_declaration_no"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field
                                                error={
                                                  touched.import_declaration_no &&
                                                    errors.import_declaration_no
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  component={MyInput}
                                                  name={`deliveries[${index}].import_declaration_no`}
                                                /* value={
                                                  values.import_declaration_no
                                                } */
                                                />
                                                {touched.import_declaration_no &&
                                                  errors.import_declaration_no ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `delivery_form.import_declaration_no.error_msg.${errors.import_declaration_no}`
                                                    ) ||
                                                      errors.import_declaration_no}
                                                  </div>
                                                ) : null}
                                              </FormUi.Field>
                                            </Table.Cell>
                                            <Table.Cell>
                                              <FormUi.Field>
                                                <label className="labelName">
                                                  {props.t(
                                                    "delivery_form.boarding_no.title"
                                                  ) || "boarding_no"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field
                                                error={
                                                  touched.boarding_no &&
                                                    errors.boarding_no
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  component={MyInput}
                                                  name={`deliveries[${index}].boarding_no`}
                                                /* value={values.boarding_no} */
                                                />
                                                {touched.boarding_no &&
                                                  errors.boarding_no ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `delivery_form.boarding_no.error_msg.${errors.boarding_no}`
                                                    ) || errors.boarding_no}
                                                  </div>
                                                ) : null}
                                              </FormUi.Field>
                                            </Table.Cell>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </Table.Row>
                                    </>
                                  )}
                                {props.movement_type == "export" ? (
                                  <>
                                    <Table.Row>
                                      <Table.Cell>
                                        <Fieldmik
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          component={MyInput}
                                          style={{
                                            paddingTop: "5.5px",
                                            whiteSpace: "nowrap",
                                          }}
                                          label={
                                            props.t(
                                              "delivery_form.do_no.title"
                                            ) || "DO No"
                                          }
                                          name={`deliveries[${index}].do_no`}
                                        />
                                        {/* </FormUi.Field> */}
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.do_date.title"
                                            ) || "DO Date"}{" "}
                                            <MandatoryMark />
                                          </label>
                                        </FormUi.Field>
                                        <DateData
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          style={{
                                            opacity: "1",
                                          }}
                                          name={`deliveries[${index}].do_validity_date_t`}
                                          tname={`deliveries[${index}].do_validity_date`}
                                          autoComplete="off"
                                          // showTimeSelect
                                          timeFormat="HH:mm"
                                          popperClassName="dateTime"
                                          dateFormat="dd/MM/yyyy"
                                          timeIntervals={5}
                                          customInput={
                                            <Input
                                              icon="time"
                                              // className="dateWidth"
                                              iconPosition="left"
                                            />
                                          }
                                        />
                                        {/* </FormUi.Field> */}
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.shiping_line.title"
                                            ) || "Shipping Line"}{" "}
                                            {/* <MandatoryMark /> */}
                                          </label>
                                        </FormUi.Field>
                                        <Dropdown
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          name={`deliveries[${index}].shipping_line_id`}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.shiping_line.title"
                                            ) || "Shipping Line"
                                          }
                                          defaultValue={
                                            values.deliveries[index]
                                              .shipping_line_id
                                          }
                                          onChange={(name, data) =>
                                            setFieldValue(
                                              `deliveries[${index}].shipping_line_id`,
                                              data.value
                                            )
                                          }
                                          options={shipingline}
                                        />
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.cha.title"
                                            ) || "CHA"}{" "}
                                            {/* <MandatoryMark /> */}
                                          </label>
                                        </FormUi.Field>
                                        <Dropdown
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                          }}
                                          search
                                          name={`deliveries[${index}].cha_id`}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.cha.title"
                                            ) || "CHA"
                                          }
                                          defaultValue={
                                            values.deliveries[index].cha_id
                                          }
                                          onChange={(name, data) =>
                                            setFieldValue(
                                              `deliveries[${index}].cha_id`,
                                              data.value
                                            )
                                          }
                                          options={cha}
                                        />
                                      </Table.Cell>
                                      {/* <Table.Cell >
                                          <FormUi.Field className="m-0 mb-2">
                                            <label className="labelName">
                                              {props.t("delivery_form.do_no.title") ||
                                                "DO No"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field
                                            width={3}
                                            error={
                                              touched.container_type && errors.container_type
                                                ? true
                                                : false
                                            }
                                          >
                                            <Dropdown
                                              clearable
                                              style={{ width: "100%", fontWeight: "normal" }}
                                              search
                                              name={`deliveries[${index}].container_type_id`}
                                              selection
                                              placeholder={
                                                props.t("delivery_form.container_type_id.title") ||
                                                "Container Type"
                                              }
                                              defaultValue={
                                                values.deliveries[index].container_type_id
                                              }
                                              onChange={(name, data) =>
                                                setFieldValue(`deliveries[${index}].container_type_id`, data.value)
                                              }
                                              options={containerType}
                                            />
                                            {touched.container_type &&
                                              errors.container_type ? (
                                              <div className="w3-small w3-text-red">
                                                {props.t(
                                                  `container_type_id.error_msg.${errors.container_type_id}`
                                                ) || errors.container_type_id}
                                              </div>
                                            ) : null}
                                          </FormUi.Field>
                                        </Table.Cell> */}
                                    </Table.Row>
                                  </>
                                ) : null}
                                {Number(
                                  localStorage.getItem("customerNumber")
                                ) != 549 &&
                                  Number(
                                    localStorage.getItem("customerNumber")
                                  ) != 1183 ? (
                                  <>
                                    <Table.Row>
                                      {Number(
                                        localStorage.getItem("customerNumber")
                                      ) != 1122 ? (
                                        <>
                                          <Table.Row>
                                            {Number(
                                              localStorage.getItem(
                                                "customerNumber"
                                              )
                                            ) != 1122 ? (
                                              <Table.Cell>
                                                <FormUi.Field
                                                  width={3}
                                                  className="m-0 mb-2"
                                                >
                                                  <label
                                                    className="labelName"
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {props.t(
                                                      "delivery_form.billing_party.title"
                                                    ) || "Billing Party"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  style={{
                                                    opacity: "1",
                                                  }}
                                                  name={`deliveries[${index}].billing_party_id`}
                                                  defaultValue={
                                                    values.deliveries[index]
                                                      .billing_party_id
                                                  }
                                                  placeholder={
                                                    props.t(
                                                      "delivery_form.billing_party.placeholder"
                                                    ) || "Billing Party"
                                                  }
                                                  component={
                                                    MyBillingPartyComponent
                                                  }
                                                  getBillingPartySelected={
                                                    getBillingPartySelected
                                                  }
                                                  onChange={(name, data) => {
                                                    setFieldValue(
                                                      `deliveries[${index}].billing_party_id`,
                                                      +data.value
                                                    );
                                                    checkBillingParty(name, data, setFieldValue, `deliveries[${index}].customer_type_id`, `deliveries[${index}].customer_type_name`);
                                                  }}
                                                />
                                                {touched.billing_party_id &&
                                                  errors.billing_party_id ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `proposed_vehicle_type.error_msg.${errors.billing_party_id}`
                                                    ) ||
                                                      errors.billing_party_id}
                                                  </div>
                                                ) : null}
                                              </Table.Cell>
                                            ) : null}
                                            {Number(
                                              localStorage.getItem(
                                                "customerNumber"
                                              )
                                            ) != 1122 ? (
                                              <Table.Cell>
                                                <FormUi.Field
                                                  width={3}
                                                  className="m-0 mb-2"
                                                >
                                                  <label
                                                    className="labelName"
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {props.t(
                                                      "delivery_form.billing_party_branch.title"
                                                    ) ||
                                                      "Billing Party Branch"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <Dropdown
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  name={`deliveries[${index}].billing_party_branch_id`}
                                                  placeholder={
                                                    values.deliveries[index]
                                                      .billing_party_branch_name
                                                      ? values.deliveries[index]
                                                        .billing_party_branch_name
                                                      : props.t(
                                                        "delivery_form.billing_party_branch.placeholder"
                                                      ) ||
                                                      "Billing Party Branch"
                                                  }
                                                  clearable
                                                  style={{
                                                    width: "100%",
                                                    opacity: "1",
                                                  }}
                                                  selection
                                                  search
                                                  onChange={(name, data) => {
                                                    data.options.map(
                                                      (item, o) => {
                                                        if (
                                                          item.raw
                                                            .billingPartyBranchId ==
                                                          data.value
                                                        ) {
                                                          setFieldValue(
                                                            `deliveries[${index}].billing_party_branch_name`,
                                                            item.raw
                                                              .billingPartyBranchName
                                                          );
                                                        }
                                                      }
                                                    );
                                                    setFieldValue(
                                                      `deliveries[${index}].billing_party_branch_id`,
                                                      +data.value
                                                    );
                                                  }}
                                                  options={billingpartybranch}
                                                />
                                              </Table.Cell>
                                            ) : null}
                                            {localStorage.getItem(
                                              "billingpartIds"
                                            ) != "" ? (
                                              <Table.Cell>
                                                <FormUi.Field
                                                  width={3}
                                                  className="m-0 mb-2"
                                                >
                                                  <label
                                                    className="labelName"
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {props.t(
                                                      "delivery_form.customer_type.title"
                                                    ) || "Customer Type"}{" "}
                                                  </label>
                                                </FormUi.Field>
                                                <Dropdown
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  clearable
                                                  style={{
                                                    width: "100%",
                                                    fontWeight: "normal",
                                                    opacity: "1",
                                                  }}
                                                  search
                                                  selection
                                                  name={`deliveries[${index}].customer_type_name`}
                                                  placeholder={
                                                    values?.deliveries?.[index]
                                                      ?.customer_type_name ?
                                                      values.deliveries[index]
                                                        .customer_type_name :
                                                      props.t(
                                                        "delivery_form.customer_type.placeholder"
                                                      ) || "Customer Type"
                                                  }
                                                  value={
                                                    values.deliveries[index]
                                                      .customer_type_id
                                                  }
                                                  onChange={(name, data) => {
                                                    if (data?.value) {
                                                      setFieldValue(
                                                        `deliveries[${index}].customer_type_id`,
                                                        data.value
                                                      )
                                                    } else {
                                                      setFieldValue(
                                                        `deliveries[${index}].customer_type_name`,
                                                        null
                                                      )
                                                    }

                                                  }
                                                  }
                                                  // onChange={(name, data) => {
                                                  //   data.options.map(
                                                  //     (item, o) => {
                                                  //       if (
                                                  //         item.raw
                                                  //           .customer_type_id ==
                                                  //         data.value
                                                  //       ) {
                                                  //         setFieldValue(
                                                  //           `deliveries[${index}].customer_type_name`,
                                                  //           item.raw
                                                  //             .customer_type_name
                                                  //         );
                                                  //       }
                                                  //     }
                                                  //   );
                                                  //   setFieldValue(
                                                  //     `deliveries[${index}].customer_type_id`,
                                                  //     +data.value
                                                  //   );
                                                  // }}
                                                  options={customertype}
                                                />
                                                {touched.customer_type_id &&
                                                  errors.customer_type_id ? (
                                                  <div className="w3-small w3-text-red">
                                                    {props.t(
                                                      `proposed_vehicle_type.error_msg.${errors.customer_type_id}`
                                                    ) ||
                                                      errors.customer_type_id}
                                                  </div>
                                                ) : null}
                                              </Table.Cell>
                                            ) : null}
                                          </Table.Row>
                                        </>
                                      ) : null}

                                      <Table.Cell>
                                        <FormUi.Field width={3}>
                                          <label
                                            className="m-0 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {props.t(
                                              "delivery_form.deliver_to.title"
                                            ) || "Deliver To"}{" "}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                          width={3}
                                          error={
                                            touched.deliver_to &&
                                              errors.deliver_to
                                              ? true
                                              : false
                                          }
                                        >
                                          <Dropdown
                                            disabled={
                                              props?.mode == "view"
                                                ? true
                                                : false
                                            }
                                            name={`deliveries[${index}].deliver_to`}
                                            clearable
                                            style={{
                                              width: "100%",
                                              fontWeight: "normal",
                                              opacity: "1",
                                            }}
                                            selection
                                            placeholder={
                                              props.t(
                                                "delivery_form.deliver_to.placeholder"
                                              ) || "Deliver To"
                                            }
                                            onChange={(name, data) => {
                                              if (data.value == "consignee") {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  values.deliveries[index]
                                                    .consignee_address
                                                );
                                              } else if (
                                                data.value == "other"
                                              ) {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  ""
                                                );
                                              }
                                              setFieldValue(
                                                `deliveries[${index}].deliver_to`,
                                                data.value
                                              );
                                            }}
                                            options={[
                                              {
                                                key: "1",
                                                text: "Consignee",
                                                value: "consignee",
                                              },
                                              {
                                                key: "2",
                                                text: "Branch",
                                                value: "branch",
                                              },
                                              {
                                                key: "3",
                                                text: "Other",
                                                value: "other",
                                              },
                                            ]}
                                            value={
                                              values.deliveries[index]
                                                .deliver_to
                                                ? values.deliveries[index]
                                                  .deliver_to
                                                : "consignee"
                                            }
                                          />
                                          {touched.deliver_to &&
                                            errors.deliver_to ? (
                                            <div className="w3-small w3-text-red">
                                              {props.t(
                                                `shipment_form.deliver_to.error_msg.${errors.deliver_to}`
                                              ) || errors.deliver_to}
                                            </div>
                                          ) : null}
                                        </FormUi.Field>
                                      </Table.Cell>

                                      {values.deliveries[index].deliver_to ==
                                        "branch" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.deliver_to_branch.title"
                                                ) || "Deliver To"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <Dropdown
                                              disabled={
                                                props?.mode == "view"
                                                  ? true
                                                  : false
                                              }
                                              name={`deliveries[${index}].deliver_to_address`}
                                              clearable
                                              style={{
                                                width: "100%",
                                                fontWeight: "normal",
                                                opacity: "1",
                                              }}
                                              selection
                                              placeholder={
                                                props.t(
                                                  "delivery_form.deliver_to_branch.placeholder"
                                                ) || "Deliver To"
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue(
                                                  `deliveries[${index}].deliver_to_address`,
                                                  data.value
                                                );
                                              }}
                                              options={branchs}
                                              value={
                                                values.deliveries[index]
                                                  .deliver_to_address
                                              }
                                            />
                                          </Table.Cell>
                                        </>
                                      ) : null}
                                      {values.deliveries[index].deliver_to ==
                                        "other" ? (
                                        <>
                                          <Table.Cell>
                                            <FormUi.Field width={3}>
                                              <label
                                                className="m-0 mb-2"
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {props.t(
                                                  "delivery_form.reason.title"
                                                ) || "Reason"}{" "}
                                              </label>
                                            </FormUi.Field>
                                            <FormUi.Field
                                              error={
                                                touched.other && errors.other
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <Fieldmik
                                                disabled={
                                                  props?.mode == "view"
                                                    ? true
                                                    : false
                                                }
                                                component="textarea"
                                                style={{
                                                  paddingTop: "5.5px",
                                                  whiteSpace: "nowrap",
                                                  opacity: "1",
                                                }}
                                                type="number"
                                                rows="2"
                                                name={`deliveries[${index}].deliver_to_address`}
                                              />
                                            </FormUi.Field>
                                          </Table.Cell>
                                        </>
                                      ) : (
                                        <>
                                          {values.deliveries[index]
                                            .deliver_to == "consignee" ? (
                                            <>
                                              <Table.Cell>
                                                <label className="labelName">
                                                  {props.movement_type ==
                                                    "import" ||
                                                    props.movement_type ==
                                                    "export" ? (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.delivery_location_address.title"
                                                      ) ||
                                                        "Delivery Location Address"}{" "}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {props.t(
                                                        "delivery_form.consignee_address.title"
                                                      ) ||
                                                        "Consignee Address"}{" "}
                                                    </>
                                                  )}
                                                </label>
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  style={{
                                                    opacity: "1",
                                                  }}
                                                  readOnly
                                                  component="textarea"
                                                  rows="2"
                                                  name={`deliveries[${index}].deliver_to_address`}
                                                  value={
                                                    values.deliveries[index]
                                                      .deliver_to_address
                                                  }
                                                />
                                              </Table.Cell>
                                            </>
                                          ) : null}
                                        </>
                                      )}
                                      {
                                        FEATURES.contractualCustomerFieldEnabled &&
                                        <Table.Cell>
                                                <label className="labelName">
                                                  
                                                      {props.t(
                                                        "delivery_form.contractual_customer.title"
                                                      ) ||
                                                        "Contractual Customer"}
                                                   
                                                </label>
                                                <FormUi.Field>
                                                <Fieldmik
                                                  disabled={
                                                    props?.mode == "view"
                                                      ? true
                                                      : false
                                                  }
                                                  component={MyBillingPartyComponent}
                                                  name={`deliveries[${index}].contractual_customer_id`}
                                                  value={
                                                    values.deliveries[index]
                                                      .contractual_customer_id
                                                  }
                                                />
                                                { errors?.deliveries?.[index]?.contractual_customer_id &&
                                                   <small className="text-danger">{errors?.deliveries?.[index]?.contractual_customer_id}</small>
                                                }
                                                </FormUi.Field>
                                              
                                              </Table.Cell>
                                      }
                                    </Table.Row>
                                  </>
                                ) : null}
                                <>
                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <h3 className="sub-heading-adjust">
                                        {localStorage.getItem("customerNumber") == 1360 ?
                                          <>Billing Party Freight Details</>
                                          :
                                          <>Freight Details</>
                                        }
                                      </h3>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">

                                      <Button
                                        basic
                                        color="green"
                                        type="button"
                                        size="mini"
                                        icon
                                        onClick={() => {
                                          evaluateFreightRate(
                                            values,
                                            setFieldValue,
                                            `deliveries[${index}].proposed_freight_rate`,
                                            `deliveries[${index}].actual_freight_rate`,
                                            `deliveries[${index}].final_freight_rate`,
                                            `deliveries[${index}].CFTKGFactor`,
                                            index
                                          );
                                        }}
                                      >
                                        Evaluate Freight
                                      </Button>
                                    </Table.Cell>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.proposed_freight_rate.title"
                                          ) || "Proposed Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          style={{
                                            opacity: "1",
                                          }}
                                          type="number"
                                          name={`deliveries[${index}].proposed_freight_rate`}
                                          //disabled={true}
                                          readonly
                                          value={
                                            values.deliveries[index]
                                              .proposed_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t("delivery_form.uom.title") ||
                                            "UoM"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Dropdown
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          name={`deliveries[${index}].uom`}
                                          clearable
                                          style={{
                                            width: "100%",
                                            fontWeight: "normal",
                                            opacity: "1",
                                          }}
                                          selection
                                          placeholder={
                                            props.t(
                                              "delivery_form.uom.title"
                                            ) || "Unit Of Measurement"
                                          }
                                          options={[
                                            {
                                              key: "4",
                                              text: "Trip",
                                              value: "trip",
                                            },
                                            {
                                              key: "2",
                                              text: "KG",
                                              value: "kg",
                                            },
                                            {
                                              key: "5",
                                              text: "Ton",
                                              value: "ton",
                                            },
                                            {
                                              key: "6",
                                              text: "KM",
                                              value: "km",
                                            },
                                            {
                                              key: "7",
                                              text: "Per Case",
                                              value: "percase",
                                            },
                                            {
                                              key: "8",
                                              text: "CFT",
                                              value: "cft",
                                            },
                                            {
                                              key: "9",
                                              text: "CFT KG Factor",
                                              value: "CFTKGFactor",
                                            },
                                          ]}
                                          defaultValue={"ton"}
                                          value={values.deliveries[index].uom}
                                          onChange={(name, data) => {
                                            setFieldValue(
                                              `deliveries[${index}].uom`,
                                              data.value
                                            );
                                            let multiplyFactor = 0,
                                              actualValue = 0;
                                            let actualFreightValue =
                                              values?.deliveries?.[index]
                                                ?.actual_freight_rate;

                                            if (
                                              values?.deliveries?.[index]?.uom
                                            ) {
                                              if (data.value === "trip") {
                                                actualValue =
                                                  actualFreightValue;
                                                setFieldValue(
                                                  `deliveries[${index}].final_freight_rate`,
                                                  actualValue
                                                );
                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                              } else if (data.value === "kg") {
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.charged_weight
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .charged_weight;
                                                  actualValue =
                                                    multiplyFactor *
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                } else {
                                                  actualValue =
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                }
                                              } else if (data.value === "ton") {
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.charged_weight
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .charged_weight / 1000;
                                                  actualValue =
                                                    multiplyFactor *
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                } else {
                                                  actualValue =
                                                    actualFreightValue / 1000;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                }
                                              } else if (data.value === "km") {
                                                if (props?.bdistance) {
                                                  multiplyFactor =
                                                    props.bdistance;
                                                  actualValue =
                                                    multiplyFactor *
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                } else {
                                                  actualValue =
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                }
                                              } else if (
                                                data.value === "percase"
                                              ) {
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.total_quantity
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .total_quantity;
                                                  actualValue =
                                                    multiplyFactor *
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                } else {
                                                  actualValue =
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                }
                                              } else if (data.value === "cft") {
                                                let tempVolume = 0;
                                                for (
                                                  let indx = 0;
                                                  indx <
                                                  values.deliveries[index]
                                                    .products.length;
                                                  indx++
                                                ) {
                                                  if (
                                                    values?.deliveries?.[index]
                                                      ?.products[indx].length &&
                                                    values?.deliveries?.[index]
                                                      ?.products[indx]
                                                      .breadth &&
                                                    values?.deliveries?.[index]
                                                      ?.products[indx].height
                                                  ) {
                                                    tempVolume =
                                                      tempVolume +
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx].length *
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx]
                                                        .breadth *
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx]
                                                        .height;
                                                  }
                                                }
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.total_quantity
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .total_quantity *
                                                    tempVolume;
                                                  actualValue =
                                                    multiplyFactor *
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                } else {
                                                  actualValue =
                                                    actualFreightValue;
                                                  setFieldValue(
                                                    `deliveries[${index}].final_freight_rate`,
                                                    actualValue
                                                  );
                                                  setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                }
                                              }
                                            }
                                          }}
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    {values?.deliveries?.[index]?.uom === "CFTKGFactor" ?
                                      <Table.Cell colSpan="1">
                                        <FormUi.Field className="m-0 mb-2">
                                          <label className="labelName">
                                            {props.t(
                                              "delivery_form.cft_factor.title"
                                            ) || "CFT KG Factor"}{" "}
                                            {/* <MandatoryMark /> */}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field className="m-0 mb-2">
                                          <Input
                                            type="number"
                                            name={`deliveries[${index}].CFTKGFactor`}
                                            //disabled={true}
                                            readonly
                                            value={
                                              values.deliveries[index]
                                                .CFTKGFactor
                                            }
                                          />
                                        </FormUi.Field>
                                      </Table.Cell>
                                      : null}
                                  </Table.Row>

                                  <Table.Row>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.actual_freight_rate.title"
                                          ) || "Actual Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          style={{
                                            opacity: "1",
                                          }}
                                          type="number"
                                          name={`deliveries[${index}].actual_freight_rate`}
                                          onChange={(name, data) => {
                                            let actualValue = 0;
                                            setFieldValue(
                                              `deliveries[${index}].actual_freight_rate`,
                                              data.value
                                            );
                                            if (
                                              values?.deliveries?.[index]?.uom
                                            ) {
                                              if (
                                                values.deliveries[index].uom ===
                                                "trip"
                                              ) {
                                                actualValue = data.value;
                                              } else if (
                                                values.deliveries[index].uom ===
                                                "kg"
                                              ) {
                                                let multiplyFactor;
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.charged_weight
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .charged_weight;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                } else {
                                                  actualValue = data.value;
                                                }
                                              } else if (
                                                values.deliveries[index].uom ===
                                                "ton"
                                              ) {
                                                let multiplyFactor;
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.charged_weight
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .charged_weight / 1000;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                } else {
                                                  actualValue =
                                                    data.value / 1000;
                                                }
                                              } else if (
                                                values.deliveries[index].uom ===
                                                "km"
                                              ) {
                                                let multiplyFactor;
                                                if (props?.bdistance) {
                                                  multiplyFactor =
                                                    props.bdistance;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                } else {
                                                  actualValue = data.value;
                                                }
                                              } else if (
                                                values.deliveries[index].uom ===
                                                "percase"
                                              ) {
                                                let multiplyFactor;
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.total_quantity
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .total_quantity;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                } else {
                                                  actualValue = data.value;
                                                }
                                              } else if (
                                                values.deliveries[index].uom ===
                                                "cft"
                                              ) {
                                                let multiplyFactor;
                                                let tempVolume = 0;
                                                for (
                                                  let indx = 0;
                                                  indx <
                                                  values.deliveries[index]
                                                    .products.length;
                                                  indx++
                                                ) {
                                                  if (
                                                    values?.deliveries?.[index]
                                                      ?.products[indx].length &&
                                                    values?.deliveries?.[index]
                                                      ?.products[indx]
                                                      .breadth &&
                                                    values?.deliveries?.[index]
                                                      ?.products[indx].height
                                                  ) {
                                                    tempVolume =
                                                      tempVolume +
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx].length *
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx]
                                                        .breadth *
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.products[indx]
                                                        .height;
                                                  }
                                                }
                                                if (
                                                  values?.deliveries?.[index]
                                                    ?.total_quantity
                                                ) {
                                                  multiplyFactor =
                                                    values.deliveries[index]
                                                      .total_quantity *
                                                    tempVolume;
                                                  actualValue =
                                                    multiplyFactor * data.value;
                                                } else {
                                                  actualValue = data.value;
                                                }
                                              }
                                            }
                                            setFieldValue(
                                              `deliveries[${index}].final_freight_rate`,
                                              actualValue
                                            );
                                            setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                          }}
                                          value={
                                            values.deliveries[index]
                                              .actual_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                    <Table.Cell colSpan="1">
                                      <FormUi.Field className="m-0 mb-2">
                                        <label className="labelName">
                                          {props.t(
                                            "delivery_form.final_freight_rate.title"
                                          ) || "Final Freight Rate"}{" "}
                                          {/* <MandatoryMark /> */}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field className="m-0 mb-2">
                                        <Input
                                          disabled={
                                            props?.mode == "view" ? true : false
                                          }
                                          style={{
                                            opacity: "1",
                                          }}
                                          type="number"
                                          name={`deliveries[${index}].final_freight_rate`}
                                          //disabled={true}
                                          readonly
                                          /* onChange={(name, data) => {
                                            setFieldValue(`deliveries[${index}].final_freight_rate`, data.value);
                                            setFieldValue(`deliveries[${index}].actual_freight_rate`, data.value);
                                          }} */
                                          value={
                                            values.deliveries[index]
                                              .final_freight_rate
                                          }
                                        />
                                      </FormUi.Field>
                                    </Table.Cell>
                                  </Table.Row>
                                </>
                                <Table.Row className="mb-4 mt-4">
                                  <div className='col-md-12'>
                                    <TableB size='sm' className='ui unstackable table'>
                                      <thead>
                                        <tr className='tr-heading'>
                                          <td> Other Charges</td>
                                          <td>Amount</td>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <FieldArray
                                          name={`deliveries[${index}].lr_other_charges`}
                                          render={(arrayHelpers) => {
                                            values.deliveries[index].charges = 0
                                            return (
                                              <>
                                                {values?.deliveries[index]?.lr_other_charges?.map(
                                                  (object, ind) => {
                                                    values.deliveries[index].charges +=
                                                      +object.charges
                                                    return (
                                                      <>
                                                       <tr key={index}>
                                                          <td style={{ width: '25%' }}>
                                                            <Fieldmik
                                                              size='mini'
                                                              className='labelName'
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_code`}
                                                              placeholder={  values.deliveries[index].lr_other_charges[ind].charge_type_desc}
                                                              advanceMode={true}
                                                              component={MyPSLineItem}
                                                              advanceType="Vendor"
                                                              id={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                            />
                                                            <ErrorMessage
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                            />
                                                          </td>
                                                          <td>
                                                            <Fieldmik
                                                              size='mini'
                                                              type='number'
                                                              min='1'
                                                              component={MyNormalInput}
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                              onBlur={() => {
                                                                if (values.deliveries[index].charges) {
                                                                  setFieldValue(`deliveries[${index}].final_rate`, Number(values.deliveries[index].final_freight_rate) + values.deliveries[index].charges)
                                                                }
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                            />

                                                          </td>
                                                          <td>
                                                            <Button
                                                              basic
                                                              color="red"
                                                              type="button"
                                                              id={ind}
                                                              onClick={(e) => {
                                                                setFieldValue(`deliveries[${index}].final_rate`, Number(values.deliveries[index].final_rate) - +object.charges)
                                                                arrayHelpers.remove(ind);
                                                              }}
                                                              size='mini'
                                                            >
                                                              <i className='fa fa-trash' color="red"></i>
                                                            </Button>
                                                          </td>
                                                        </tr>
                                                      </>
                                                    )
                                                  }
                                                )}
                                                <tr>
                                                  <td>Total</td>
                                                  <td>{values.deliveries[index].charges}</td>
                                                </tr>
                                                <Button
                                                  basic
                                                  color="blue"
                                                  className="m-2"
                                                  type="button"
                                                  size="mini"
                                                  onClick={() =>
                                                    arrayHelpers.push({
                                                      charge_type_id: '',
                                                      charges: '',
                                                    })
                                                  }
                                                >
                                                  + Add More Expense
                                                </Button>
                                              </>
                                            )
                                          }}
                                        />
                                      </tbody>
                                    </TableB>
                                    <FormUi.Field className="m-0 mb-2">
                                      <label className="labelName">
                                        {"Final Rate"}{" "}
                                        {/* <MandatoryMark /> */}
                                      </label>
                                    </FormUi.Field>
                                    <FormUi.Field className="m-0 mb-2">
                                      <Input
                                        type="number"
                                        name={`deliveries[${index}].final_rate`}
                                        readonly
                                        value={
                                          values.deliveries[index]
                                            .final_rate
                                        }
                                      />
                                    </FormUi.Field>
                                  </div>
                                </Table.Row>
                                <Table.Row>
                                  <>
                                    <Table.Cell>
                                      <label className="labelName">
                                        {localStorage.getItem("customerNumber") == 1166 ? "STO/SO/RGP-NRGP/LineItems" : "Remarks"}
                                      </label>
                                      <Fieldmik
                                        disabled={
                                          props?.mode == "view" ? true : false
                                        }
                                        component="textarea"
                                        style={{
                                          paddingTop: "5.5px",
                                          whiteSpace: "nowrap",
                                          opacity: "1",
                                        }}
                                        type="text"
                                        rows="2"
                                        name={`deliveries[${index}].remarks`}
                                        values={
                                          values.deliveries[index].remarks
                                        }
                                      />
                                    </Table.Cell>
                                  </>
                                </Table.Row>
                                <Table.Row key={`Invoice` + index} colSpan="9">
                                  <Table.Cell colSpan="9">
                                    <FieldArray
                                      key={`invoice_form` + index}
                                      name={`deliveries[${index}].invoices`}
                                      render={(deliveryInvoices) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].invoices.map((invoice, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row colSpan="9">
                                                  <Table.HeaderCell colSpan="6">
                                                    {props.t(
                                                      "invoice_form.title"
                                                    ) || "Invoice"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryInvoices.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                {/* <Table.Row> */}
                                                <Grid columns={4} className='m-2'>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_code.title"
                                                        ) || "Invoice No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                      type="text"
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                        trans={
                                                          "invoice_form.invoice_code"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>

                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_reference_no.title"
                                                        ) || "Invoice Reference Number"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_reference_no`}
                                                      type="text"
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_reference_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_reference_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_reference_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_reference_no`}
                                                        trans={
                                                          "invoice_form.invoice_reference_no"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>

                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_amount.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_amount`}
                                                      type="number"
                                                      // onChange={(
                                                      //   name,
                                                      //   data
                                                      // ) => {
                                                      //   setFieldValue(
                                                      //     `deliveries[${index}].invoices[${i}].invoice_amount`,
                                                      //     data.value
                                                      //   );
                                                      // }}
                                                      //defaultValue={
                                                      value={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_amount
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_amount`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_amount`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_amount`}
                                                        trans={
                                                          "invoice_form.invoice_amount"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <label>
                                                      {props.t(
                                                        "invoice_form.invoice_date.title"
                                                      ) || "Invoice Date"}
                                                    </label>
                                                    <br></br>
                                                    <DateData
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_date_t`}
                                                      tname={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                      autoComplete="off"
                                                      maxDate={moment().toDate()}
                                                      value={values.deliveries[index].invoices[i].invoice_date}
                                                      // showTimeSelect
                                                      timeFormat="HH:mm"
                                                      popperClassName="dateTime"
                                                      dateFormat="dd/MM/yyyy HH:mm"
                                                      timeIntervals={5}
                                                      customInput={
                                                        <Input
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_date`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_date`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                        trans={
                                                          "invoice_form.invoice_date"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        // width: "125px"
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                      type="number"
                                                      // onChange={(
                                                      //   name,
                                                      //   data
                                                      // ) => {
                                                      //   setFieldValue(
                                                      //     `deliveries[${index}].invoices[${i}].invoice_quantity`,
                                                      //     data.value
                                                      //   );
                                                      // }}
                                                      //defaultValue={
                                                      value={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .invoice_quantity
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                        trans={
                                                          "invoice_form.invoice_quantity"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        "Eway Bill No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].eway_bill_no`}
                                                      type="number"
                                                      // onChange={(
                                                      //   name,
                                                      //   data
                                                      // ) => {
                                                      //   setFieldValue(
                                                      //     `deliveries[${index}].invoices[${i}].invoice_amount`,
                                                      //     data.value
                                                      //   );
                                                      // }}
                                                      //defaultValue={
                                                      value={
                                                        values.deliveries[index]
                                                          .invoices[i]
                                                          .eway_bill_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].eway_bill_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        className="fileTypes"
                                                        name={`deliveries[${index}].invoices[${i}].eway_bill_no`}
                                                      />
                                                    }
                                                  </Grid.Column>
                                                  <Grid.Column>
                                                    <label>
                                                      Eway Bill Expiry Date
                                                    </label>
                                                    <br></br>
                                                    <DateData
                                                      tname={`deliveries[${index}].invoices[${i}].eway_bill_expirydate`}
                                                      name={`deliveries[${index}].invoices[${i}].eway_bill_expirydate_t`}
                                                      //  tname={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                      autoComplete="off"
                                                      //maxDate={moment().toDate()}
                                                      minDate={moment().toDate()}
                                                      filterDate={(date) => {
                                                        return moment() < date;
                                                      }}
                                                      // showTimeSelect
                                                      timeFormat="HH:mm"
                                                      popperClassName="dateTime"
                                                      dateFormat="dd/MM/yyyy HH:mm"
                                                      timeIntervals={5}
                                                      value={values.deliveries[index].invoices[i].eway_bill_expirydate}
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      customInput={
                                                        <Input
                                                          value={values.deliveries[index].invoices[i].eway_bill_expirydate}
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      } />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].eway_bill_expirydate`}
                                                        trans={
                                                          "invoice_form.eway_bill_expirydate"
                                                        }
                                                      />
                                                    }
                                                  </Grid.Column>
                                                </Grid>
                                                <Table.Row>
                                                  {props.movement_type ==
                                                    "import" ? (
                                                    <>
                                                      <Table.Cell>
                                                        <Fieldmik
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            opacity: "1",
                                                          }}
                                                          label={
                                                            props.t(
                                                              "invoice_form.boe_no.title"
                                                            ) || "BOE No"
                                                          }
                                                          name={`deliveries[${index}].invoices[${i}].boe_no`}
                                                          type="text"
                                                        />
                                                      </Table.Cell>

                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "invoice_form.boe_date.title"
                                                          ) || "Invoice Date"}
                                                        </label>
                                                        <br></br>
                                                        <DateData
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          style={{
                                                            opacity: "1",
                                                          }}
                                                          name={`deliveries[${index}].invoices[${i}].boe_date`}
                                                          tname={`deliveries[${index}].invoices[${i}].boe_date`}
                                                          autoComplete="off"
                                                          // showTimeSelect
                                                          timeFormat="HH:mm"
                                                          popperClassName="dateTime"
                                                          dateFormat="dd/MM/yyyy HH:mm"
                                                          timeIntervals={5}
                                                          customInput={
                                                            <Input
                                                              icon="time"
                                                              // className="dateWidth"
                                                              iconPosition="left"
                                                            />
                                                          }
                                                        />
                                                      </Table.Cell>

                                                      <Table.Cell>
                                                        <Fieldmik
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            opacity: "1",
                                                          }}
                                                          label={
                                                            props.t(
                                                              "invoice_form.bl_no.title"
                                                            ) || "Bl_No"
                                                          }
                                                          name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                          type="text"
                                                          min={0}
                                                          defaultValue={
                                                            values.deliveries[
                                                              index
                                                            ].invoices[i].bl_no
                                                          }
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].invoices[${i}].bl_no`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].invoices[${i}].bl_no`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                            trans={
                                                              "invoice_form.bl_no"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                </Table.Row>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryInvoices.push({
                                                invoice_code: null,
                                                invoice_reference_no : null ,
                                                invoice_date: null,
                                                invoice_quantity: null,
                                                invoice_amount: null,
                                                eway_bill_expirydate: null,
                                                eway_bill_no: null
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "invoice_form.action_button.add_more_invoice"
                                            ) || "Add More Invoices"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                                <Table.Row key={`product` + index}>
                                  <Table.Cell colSpan="6">
                                    <FieldArray
                                      key={`product_form` + index}
                                      name={`deliveries[${index}].products`}
                                      render={(deliveryProducts) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].products.map((product, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row>
                                                  <Table.HeaderCell colSpan="4">
                                                    {props.t(
                                                      "product_form.title"
                                                    ) || "Product"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryProducts.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_name"
                                                      ) || "Product Name"}
                                                    </label>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      type="text"
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.product_name"
                                                        ) || "Product Name"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_name`}
                                                      categoryFieldName={`deliveries[${index}].products[${i}].product_category_id`}
                                                      categoryKeyName={`deliveries[${index}].products[${i}].product_category_name`}
                                                      codeFieldName={`deliveries[${index}].products[${i}].product_code`}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_name`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_name`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      component={MySKU}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_name`}
                                                        trans={
                                                          "product_form.product_name"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  {props.movement_type ==
                                                    "primary" ? (
                                                    <>
              
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.product_category_id.title"
                                                          ) ||
                                                            "Product Category"}
                                                        </label>
                                                        <Fieldmik
                                                          disabled={
                                                            // props?.mode ==
                                                            //   "view"
                                                            //   ? true
                                                            //   : false
                                                            true
                                                          }
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].products[${i}].product_category_id`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].products[${i}].product_category_id`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                          name={`deliveries[${index}].products[${i}].product_category_name`}
                                                          placeholder={
                                                            props.t(
                                                              "product_form.product_category_id.placeholder"
                                                            ) ||
                                                            "Product Category"
                                                          }
                                                          // clearable
                                                          // style={{
                                                          //   width: "100%",
                                                          //   opacity: "1",
                                                          // }}
                                                          // selection
                                                          // search
                                                          // onChange={(
                                                          //   name,
                                                          //   data
                                                          // ) => {
                                                          //   setFieldValue(
                                                          //     `deliveries[${index}].products[${i}].product_category_id`,
                                                          //     data.value
                                                          //   );
                                                          // }}
                                                          // defaultValue={
                                                          //   values.deliveries[
                                                          //     index
                                                          //   ].products[i]
                                                          //     .product_category_id
                                                          // }
                                                          // options={
                                                          //   serviceCateogyList
                                                          // }
                                                          component={MyNormalInput}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].product_category_id`}
                                                            trans={
                                                              "product_form.product_category_id"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_code.title"
                                                      ) || "Product Code"}
                                                    </label>
                                                    <Fieldmik
                                                      disabled={
                                                        true
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_code`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_code`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_code`}
                                                      placeholder={
                                                        props.t(
                                                          "product_form.product_code.placeholder"
                                                        ) || "Product Code"
                                                      }
                                                      // clearable
                                                      // style={{
                                                      //   width: "100%",
                                                      //   opacity: "1",
                                                      // }}
                                                      // selection
                                                      // search
                                                      // onChange={(name, data) =>
                                                      //   setProductCodeAndProductName(
                                                      //     name,
                                                      //     data,
                                                      //     `deliveries[${index}].products[${i}].product_name`
                                                      //   )
                                                      // }
                                                      // defaultValue={
                                                      //   values.deliveries[index]
                                                      //     .products[i]
                                                      //     .product_code
                                                      // }
                                                      // options={products}
                                                      component={MyNormalInput}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_code`}
                                                        trans={
                                                          "product_form.product_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyNumInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].quantity`}
                                                      type="number"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i].quantity
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].quantity`}
                                                        trans={
                                                          "product_form.quantity"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  {props.movement_type ==
                                                    "primary" ? (
                                                    <>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.packaging_type_id.title"
                                                          ) || "Packaging Type"}
                                                        </label>
                                                        <Dropdown
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          error={
                                                            getIn(
                                                              errors,
                                                              `deliveries[${index}].products[${i}].packaging_type_id`
                                                            ) &&
                                                              getIn(
                                                                touched,
                                                                `deliveries[${index}].products[${i}].packaging_type_id`
                                                              )
                                                              ? true
                                                              : false
                                                          }
                                                          name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                          placeholder={
                                                            props.t(
                                                              "product_form.packaging_type_id.placeholder"
                                                            ) || "Product Code"
                                                          }
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                            opacity: "1",
                                                          }}
                                                          selection
                                                          search
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) =>
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].packaging_type_id`,
                                                              +data.value
                                                            )
                                                          }
                                                          defaultValue={`${values.deliveries[index].products[i].packaging_type_id}`}
                                                          options={packageType}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                            trans={
                                                              "product_form.packaging_type_id"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                </Table.Row>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      disabled={
                                                        props?.mode == "view"
                                                          ? true
                                                          : false
                                                      }
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        // width: "155px"
                                                        opacity: "1",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_code.title"
                                                        ) || "Invoice No"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].invoice_no`}
                                                      type="text"
                                                      value={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .invoice_no
                                                      }
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].invoice_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].invoice_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].invoice_no`}
                                                        trans={
                                                          "invoice_form.invoice_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>

                                                  {values.service_type_id ==
                                                    2 ||
                                                    values?.deliveries?.[index]
                                                      ?.uom == "cft" ? (
                                                    <>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.length"
                                                          ) || "Length"}
                                                        </label>
                                                        <Input
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          name={`deliveries[${index}].products[${i}].length`}
                                                          type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i].length
                                                          }
                                                          min={0}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].length`,
                                                              data.value == ""
                                                                ? null
                                                                : +data.value
                                                            );
                                                            let multiplyFactor = 0,
                                                              actualValue = 0;
                                                            let tempVolume = 0;
                                                            let actualFreightValue =
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]
                                                                ?.actual_freight_rate;
                                                            for (
                                                              let indx = 0;
                                                              indx <
                                                              values.deliveries[
                                                                index
                                                              ].products.length;
                                                              indx++
                                                            ) {
                                                              if (
                                                                data.value &&
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].breadth &&
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].height
                                                              ) {
                                                                tempVolume =
                                                                  tempVolume +
                                                                  data.value *
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].breadth *
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].height;
                                                              }
                                                            }
                                                            if (
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]?.total_quantity
                                                            ) {
                                                              let tempCharge = 0;

                                                              if (
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.charged_weight
                                                              ) {
                                                                tempCharge =
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]
                                                                    ?.charged_weight *
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ]
                                                                    .total_quantity *
                                                                  tempVolume;
                                                              }
                                                              multiplyFactor =
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .total_quantity *
                                                                tempVolume;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue +
                                                                tempCharge;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue *
                                                                tempVolume;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            }
                                                          }}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].length`}
                                                            trans={
                                                              "product_form.length"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.breadth"
                                                          ) || "Breadth"}
                                                        </label>
                                                        <Input
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          name={`deliveries[${index}].products[${i}].breadth`}
                                                          type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i]
                                                              .breadth
                                                          }
                                                          min={0}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].breadth`,
                                                              data.value == ""
                                                                ? null
                                                                : +data.value
                                                            );
                                                            let multiplyFactor = 0,
                                                              actualValue = 0;
                                                            let tempVolume = 0;
                                                            let actualFreightValue =
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]
                                                                ?.actual_freight_rate;
                                                            for (
                                                              let indx = 0;
                                                              indx <
                                                              values.deliveries[
                                                                index
                                                              ].products.length;
                                                              indx++
                                                            ) {
                                                              if (
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].length &&
                                                                data.value &&
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].height
                                                              ) {
                                                                tempVolume =
                                                                  tempVolume +
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].length *
                                                                  data.value *
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].height;
                                                              }
                                                            }
                                                            if (
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]?.total_quantity
                                                            ) {
                                                              let tempCharge = 0;

                                                              if (
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.charged_weight
                                                              ) {
                                                                tempCharge =
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]
                                                                    ?.charged_weight *
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ]
                                                                    .total_quantity *
                                                                  tempVolume;
                                                              }
                                                              multiplyFactor =
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .total_quantity *
                                                                tempVolume;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue +
                                                                tempCharge;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue *
                                                                tempVolume;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            }
                                                          }}
                                                        />{" "}
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].breadth`}
                                                            trans={
                                                              "product_form.breadth"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                      <Table.Cell>
                                                        <label>
                                                          {props.t(
                                                            "product_form.height"
                                                          ) || "Height"}
                                                        </label>
                                                        <Input
                                                          disabled={
                                                            props?.mode ==
                                                              "view"
                                                              ? true
                                                              : false
                                                          }
                                                          placeholder={props.t(
                                                            "product_form.lbhPlaceholder"
                                                          )}
                                                          name={`deliveries[${index}].products[${i}].height`}
                                                          type="number"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].products[i].height
                                                          }
                                                          min={0}
                                                          onChange={(
                                                            value,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].products[${i}].height`,
                                                              data.value == ""
                                                                ? null
                                                                : +data.value
                                                            );
                                                            let multiplyFactor = 0,
                                                              actualValue = 0;
                                                            let tempVolume = 0;
                                                            let actualFreightValue =
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]
                                                                ?.actual_freight_rate;
                                                            for (
                                                              let indx = 0;
                                                              indx <
                                                              values.deliveries[
                                                                index
                                                              ].products.length;
                                                              indx++
                                                            ) {
                                                              if (
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].length &&
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.products[
                                                                  indx
                                                                ].breadth &&
                                                                data.value
                                                              ) {
                                                                tempVolume =
                                                                  tempVolume +
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].length *
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].breadth *
                                                                  data.value;
                                                              }
                                                            }
                                                            if (
                                                              values
                                                                ?.deliveries?.[
                                                                index
                                                              ]?.total_quantity
                                                            ) {
                                                              let tempCharge = 0;

                                                              if (
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.charged_weight
                                                              ) {
                                                                tempCharge =
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]
                                                                    ?.charged_weight *
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ]
                                                                    .total_quantity *
                                                                  tempVolume;
                                                              }
                                                              multiplyFactor =
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .total_quantity *
                                                                tempVolume;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue +
                                                                tempCharge;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue *
                                                                tempVolume;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            }
                                                          }}
                                                        />
                                                        {
                                                          <ErrorMessages
                                                            name={`deliveries[${index}].products[${i}].height`}
                                                            trans={
                                                              "product_form.height"
                                                            }
                                                          />
                                                        }
                                                      </Table.Cell>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Table.Row>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryProducts.push({
                                                product_code: "",
                                                product_name: "",
                                                quantity: "",
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "product_form.action_button.add_more_product"
                                            ) || "Add More Products"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          ))}
                          <Modal.Actions>
                            <center>
                              {!props?.onlyDelivery ? (
                                <Button
                                  size="mini"
                                  type="button"
                                  onClick={() => addNewDelivery(arrayHelpers)}
                                  basic
                                  primary
                                  icon
                                >
                                  {" "}
                                  <Icon name="plus" />{" "}
                                  {props.t("action_button.new_delivery") ||
                                    "New Delivery"}{" "}
                                </Button>
                              ) : null}

                              <Button
                                disabled={props?.mode == "view" ? true : false}
                                size="mini"
                                primary
                                type="submit" /* onClick={(e) => { e.preventDefault(); e.stopPropagation(); formik.handleSubmit();}} */
                              >
                                {props.t("action_button.save") || "Save"}
                              </Button>

                              <Button
                                onClick={props.handleClose}
                                size="mini"
                                color="red"
                                type="button"
                              >
                                {" "}
                                {props.t("action_button.close") || "Close"}{" "}
                              </Button>
                            </center>
                          </Modal.Actions>
                        </>
                      )}
                    />
                  </Formiker>
                </Modal.Description>
              </Modal.Content>
            );
          }}
        ></Formik>
      </Modal>
    </div>
  );
};

const mapStateToPrps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToPrps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher
})(translate("create_order")(ModalEditAddDeliveries));
